export default {
  ActionConfirm: "কাজটি নিশ্চিত করুন",
  ActivatePromocode: "প্রোমোকোড সক্রিয় করুন",
  AddFile: "ফাইল সংযুক্ত করতে ক্লিক করুন",
  AddToFavorites: "ফেভারিটে যোগ করুন",
  "Andar Bahar": "আন্দার বাহার",
  ApplyFilter: "ফিল্টার প্রয়োগ করুন",
  AppsPage: {
    blocks: {
      descriptionOne: "প্রকৃত মিরর খোঁজার প্রয়োজন নেই",
      descriptionThree: "সকল প্রোমোশন, টুর্নামেন্ট ও ড্র সম্পর্কিত ব্যক্তিগত নোটিফিকেশন",
      descriptionTwo: "অ্যাপ ব্যবহারকারীদের জন্য ইউনিক প্রোমোশন ও অফার",
      titleOne: "OLYMP সবসময়ই হাতের নাগালে",
      titleThree: "সকল ইভেন্ট এবং অফারের সম্পর্কে আপ টু ডেট থাকুন",
      titleTwo: "এক্সক্লুসিভ প্রোমোশন এবং টুর্নামেন্ট"
    },
    dontWorry: "চিন্তা করবেন না, এটা নিরাপদ",
    howToInstall: "কীভাবে ইন্সটল করতে হবে",
    installAndroid: "অ্যান্ড্রয়েডের জন্য ডাউনলোড করুন",
    installIos: "iOS-এর জন্য ইন্সটল করুন",
    installIsSafe: "ইন্সটল করা নিরাপদ",
    qrText: "অ্যাপটি ডাউনলোড করতে আপনার ফোনের ক্যামেরাটি QR কোডের দিকে ধরুন",
    safeDescription: "Google-এর গ্যাম্বলিং সংক্রান্ত নীতিমালার কারণে আমরা প্লে মার্কেটে অ্যাপটি পোস্ট করতে পারছি না। ইন্সটল করতে নীচের নির্দেশাবলী অনুসরণ করুন",
    seo: {
      all: {
        block_one: {
          description: "{platform} হলো দারুণ সব বিনোদন সহ ভার্চুয়াল বেটিং ও গ্যাম্বলিংয়ের একটি আধুনিক প্ল্যাটফর্ম। আমরা ব্যবহারকারীদের স্বাচ্ছন্দ্যের দিকে বিশেষ মনোযোগ দিই, এই কারণে আমাদের অনলাইন প্ল্যাটফর্ম- কম্পিউটার এবং স্মার্টফোন সহ যেকোনো ডিভাইস থেকে ব্যবহার করা যায়। Olymp casino মোবাইল অ্যাপটি জনপ্রিয় অপারেটিং সিস্টেম - অ্যান্ড্রয়েড ও iOS-এ চলা সকল আধুনিক ফোনের জন্য তৈরি করা হয়েছে। গ্যাম্বলিং-এর প্রতি আগ্রহী ব্যক্তিরা তাদের পছন্দমতো সময়ে যেকোনো জায়গা থেকে ইন্টারনেট প্ল্যাটফর্মের মাধ্যমে সর্বোচ্চ ব্যবহার করতে পারেন।",
          title: "{platform} মোবাইল অ্যাপ"
        },
        block_three: {
          description: "অ্যাপটি ডাউনলোড এবং নিবন্ধন করা সকল প্লেয়াররা সাইটের সকল কার্যক্ষমতা এবং সম্পূর্ণ টুল সেট ব্যবহার করতে পারবেন। মোবাইল অ্যাপে ঠিক কী কী পাওয়া যায়? আপনার ব্যক্তিগত অ্যাকাউন্টের মাধ্যমে আপনি যা যা করতে পারবেন তা হলো:",
          list: {
            five: "গেমিং অ্যাকাউন্টে আর্থিক লেনদেনের ইতিহাস জানতে পারবেন - উত্তোলনের অর্ডার, পেমেন্ট এবং বেট দেখা।",
            four: "বোনাস ব্যবহার করতে পারবেন - ওয়েলকাম প্যাকেজ ও অন্যান্য গিফট।",
            one: "একটি প্রোফাইল সেট আপ করতে পারবেন - একটি ফোন নম্বর বা ইমেইল অ্যাড্রেস যোগ করুন, নিজের সম্পর্কিত তথ্য পূরণ করুন এবং পরিবর্তন করুন।",
            three: "ক্যাসিনো থেকে মেইলের মাধ্যমে পাঠানো ম্যাসেজ অনুসরণ করতে পারবেন।",
            two: "ব্যালেন্স চেক করা, যেকোনো পছন্দমতো পদ্ধতিতে জমা করা, প্রাইজের অর্থ উত্তোলন এবং ইনস্ট্যান্ট ক্যাশব্যাক পেতে পারবেন।"
          },
          text: "আপনি Olymp ক্যাসিনোতে অনলাইনে খেলতে পারবেন এবং নিবন্ধন প্রক্রিয়ার পর তাৎক্ষনাক বেট ধরতে পারবেন। আপনাকে শুধু একটি ন্যূনতম অর্থ জমা করতে হবে এবং আপনার পছন্দের বিনোদন বেছে নিতে হবে — আমাদের অ্যাপ ফিচারের স্লট মেশিন, লটারি, ফাস্ট, স্পোর্টস ও ক্লাসিক গেম, লাইভ ক্যাসিনো, স্পোর্টস বেটিং এবং বিভিন্ন টুর্নামেন্টের মধ্য থেকে। Olymp Casino অ্যাপ্লিকেশনের কোনো অনলাইন সেশন চলাকালীন আপনার কোনো প্রশ্ন থাকলে, টেকনিক্যাল সাপোর্ট আপনাকে সহায়তা করবে। একটি চ্যাট খুলে স্পেশাল ফর্মে একটি ম্যাসেজ দিলেই হবে।",
          title: "কার্যকারিতা"
        },
        block_two: {
          description: "অ্যাপ স্টোর - গুগল প্লে মার্কেট, AppGallery এবং অন্যান্য মার্কেটের - গ্যাম্বলিং সংক্রান্ত বিভিন্ন নীতিমালা রয়েছে এবং তাদের ক্যাটালগে সবসময় প্রয়োজনীয় সফটওয়্যার থাকে না। আমরা অনুসন্ধান প্রক্রিয়াটি আপনার জন্য সহজ করেছি এবং Olymp ক্যাসিনো মোবাইল অ্যাপটি সকল অপারেটিং সিস্টেমের জন্য পাবলিক ডোমেনে রেখেছি - আমাদের অফিসিয়াল সাইট থেকে সহজেই সরাসরি ডাউনলোড করতে পারবেন। আপনি নীচের অ্যাকশন অ্যালগরিদমগুলোর মধ্যে একটি বেছে নিতে পারবেন:",
          list: {
            one: "কম্পিউটার ব্যাবহার করুন। এটি করার জন্য যেকোনো ব্রাউজারের মাধ্যমে অফিসিয়াল {platform} পোর্টাল চালু করুন বা সার্চ ইঞ্জিনের মাধ্যমে একটি সক্রিয় মিরর খুলুন। সেখানে আপনি \"iOS-এর জন্য ইন্সটল করুন\" এবং \"অ্যান্ড্রয়েডের জন্য ডাউনলোড করুন\" বাটনসহ একটি পেজ পাবেন। আপনার জন্য উপযুক্ত অপশনে ক্লিক করুন এবং আপনার ফোনের ক্যামেরা ব্যবহার করে QR কোড স্ক্যান করুন। স্ক্রিনে একটি লিংক প্রদর্শিত হবে - সেটা অনুসরণ করুন। আপনি যদি কোনো iPhone ব্যবহার করেন, তাহলে আপনাকে অ্যাপ স্টোরে আমাদের অ্যাপে পুনঃনির্দেশিত করা হবে এবং সেখান থেকে আপনি অ্যাপটি ডাউনলোড করতে পারবেন। আপনি যদি অ্যান্ড্রয়েড ব্যবহার করেন, তাহলে আপনাকে অ্যাপ্লিকেশনটি ইন্সটল করার অনুমতি দিতে হবে এবং প্রক্রিয়াটি সম্পন্ন হওয়া পর্যন্ত অপেক্ষা করতে হবে।",
            two: "মোবাইল ডিভাইস ব্যবহার করুন। {platformSite} সাইটে যান - Olymp সাইটের মোবাইল সংস্করণ খুলে যাবে। বিনামূল্যে অ্যাপটি ডাউনলোড করতে হলে প্রথমে আপনার স্মার্টফোনের OS-এর উপর নির্ভর করে দুটি ডাউনলোড বাটন থেকে আপনার প্রয়োজনীয় অপশনটি নির্বাচন করুন। প্রথমে আপনার ফোনের 'সেটিংস' চেক করে আননোন ফাইল ইন্সটল করার অনুমতি দিতে ভুলবেন না - এটি নিরাপদ। অ্যাপটি কয়েক মিনিটের মধ্যে ডাউনলোড হয়ে যাবে"
          },
          text: "\"লগ ইন\"-এ ক্লিক করে অনুমোদনের জন্য এগিয়ে যান। {platform}-তে আপনার এখনো যদি কোনো অ্যাকাউন্ট না থাকে তবে এখনই সময় অ্যাকাউন্ট খোলার। সঠিক স্থানে আপনার ফোন নম্বর বা ই-মেইল লিখুন, একটি শক্তিশালী পাসওয়ার্ড দিন এবং প্রক্রিয়াটি নিশ্চিত করুন।",
          title: "অ্যাপটি কোথা থেকে ডাউনলোড করবেন"
        }
      },
      android: {
        block_four: {
          description: "{platform} মোবাইল অ্যাপটি ইংরেজি, কাজাখ, উজবেক, কিরগিজ ও রাশিয়ান ভাষায় এভেইলেবল আছে - আপনি যেকোনো সময় এটি পরিবর্তন করতে পারবেন। ফোনের মাধ্যমে সর্বোচ্চ স্বাচ্ছন্দ্যের সাথে অ্যাপটি ব্যবহারের জন্য তৈরি করা হয়েছে - মোবাইল স্ক্রিনের আকার বিবেচনা করে সকল ইন্টারফেস বিষয়গুলো এখানে নিয়ে আসা হয়েছে। সাইটের ডেস্কটপ সংস্করণের সকল ফাংশনে অনুমোদিত প্রত্যেক স্মার্টফোন মালিকের অ্যাক্সেস রয়েছে:",
          list: {
            five: "ব্যক্তিগত ম্যাসেজ।",
            four: "পেমেন্ট ইতিহাস, বেট এবং উত্তোলনের অর্ডারসমূহ।",
            one: "প্রোফাইল সেটিংস।",
            three: "প্রোমো কোড এবং গিফট - ফ্রি স্পিন, ফ্রি বেট এবং ডিপোজিট বোনাস।",
            two: "গেম অ্যাকাউন্টের কাজ - জমা, উত্তোলন ও ইনস্ট্যান্ট ক্যাশব্যাক।"
          },
          text: "এবং সবচেয়ে গুরুত্বপূর্ণ বিষয় হলো, আপনার ফোন বা ট্যাবলেটের মাধ্যমে, আপনি আপনার পছন্দের যেকোনো গেম খেলতে পারবেন, স্পোর্টস বেটিংয়ে আপনার ভাগ্য পরীক্ষা করতে পারবেন এবং প্রোমোশন ও টুর্নামেন্টে অংশ নিতে পারবেন। Casino Olymp সর্বদা আপনার আঙুলের ডগায় থাকবে এবং এর পাশাপাশি আপনাকে পারসোনালাইজড এলার্ট প্রদান করা হবে তাই, আপনি কোনো এক্সক্লুসিভ অফার মিস করবেন না।",
          title: "কার্যকারিতা"
        },
        block_one: {
          description: "যারা যেকোনো জায়গায় আনন্দের সাথে রিল্যাক্স করতে পছন্দ করেন তাদের জন্য {platform}-তে রয়েছে গ্যাম্বলিং বিনোদনের বিশাল পরিসরের অপশনের সুযোগ। স্পোর্টস বেটিং ও লটারি, ফাস্ট ও বেট গেম, লাইভ ক্যাসিনো এবং স্লট - গেমিং সফটওয়্যার আপনি আপনার ফোনের মাধ্যমে সরাসরি পাবেন! অ্যান্ড্রয়েড অপারেটিং সিস্টেমের উপর ভিত্তি করে স্মার্টফোনের মালিকরা সবকিছুই করতে পারবেন - বিশেষ করে আপনার জন্য, আমরা অ্যান্ড্রয়েডের একটি বিশেষ Olymp মোবাইল অ্যাপ তৈরি করেছি। আপনার ফোন বা ট্যাবলেটের মাধ্যমে আপনার ব্যক্তিগত অ্যাকাউন্টে অর্থ জমা করুন, আপনার ফেভারিট স্লট মেশিন ও স্লটগুলো অনলাইনে চালু করুন এবং প্রক্রিয়াটি উপভোগ করুন।",
          title: "অ্যান্ড্রয়েডের জন্য Olymp Casino অ্যাপ"
        },
        block_three: {
          description: "আপনি কি অফিসিয়াল সাইট থেকে অ্যান্ড্রয়েডের জন্য Olymp অ্যাপটি বিনামূল্যে ডাউনলোড করছেন? APK ফাইল ইন্সটল করার জন্য আপনাকে আপনার মোবাইল ডিভাইস প্রস্তুত করতে হবে। শুরু করতে, প্রয়োজনীয় অনুমতিগুলো প্রদান করুন:",
          list: {
            four: "\"এই উৎস থেকে ইনস্টলেশনের অনুমতি দিন\" অনুরোধটি স্ক্রিনে আসলে ডাউনলোড শুরু করতে বাটনটিতে ক্লিক করুন।",
            one: "আপনার স্মার্টফোনের «সেটিংস»-এ গিয়ে «অ্যাপস» খুঁজে বের করুন।",
            three: "অজানা অ্যাপ ইন্সটল করার অ্যাক্সেস প্রদান করুন।",
            two: "\"অনুমতি\" মেন্যু ওপেন করুন।"
          },
          text: "আপনি একটি QR কোড ব্যবহার করে পোর্টালের ডেস্কটপ সংস্করণের মাধ্যমে অ্যান্ড্রয়েডের জন্য Olymp অ্যাপ ডাউনলোড করতে পারেন। এটি সরাসরি পেজে প্রদর্শিত হবে - আপনাকে শুধুমাত্র কোডটির দিকে আপনার স্মার্টফোনের ক্যামেরাটি ধরে ডাউনলোড লিংকের জন্য অপেক্ষা করতে হবে। Olymp Casino-র মোবাইল সংস্করণের সাহায্যে ইন্সটলেশন প্রক্রিয়াটি কয়েকটি সহজ ধাপে সম্পন্ন হয়। স্মার্টফোনের মাধ্যমে অ্যাপটি ডাউনলোড করতে, আপনার ব্রাউজারে পোর্টালের মোবাইল সংস্করণটি খুলুন। সেখানে আপনি \"অ্যাপ ডাউনলোড করুন\" বাটনটি দেখতে পাবেন। এটিতে ক্লিক করুন - এবং আপনি \"ডাউনলোড করুন\" লেখা দেখতে পাবেন। নির্দ্বিধায় ইন্সটলেশন লিংকগুলোতে ক্লিক করুন - এগুলো নিরাপদ, এবং ফাইলটি একটি নির্ভরযোগ্য উৎস থেকে ডাউনলোড করা হবে। প্রস্তুত! আপনি মোবাইল অ্যাপের সকল সুবিধা উপভোগ করতে পারবেন। এখন আপনি কার্যকর মিরর খোঁজার বা কোনো VPN ইন্সটল করার প্রয়োজন থেকে মুক্ত - যতক্ষণ আপনার ইন্টারনেট সংযোগ থাকবে ততক্ষণ পর্যন্ত Olymp Casino মোবাইল অ্যাপটি কাজ করবে। এই অ্যাপটিকে সর্বশেষ সংস্করণে আপডেট করার প্রয়োজন হলে, সবকিছু ঠিকভাবে কাজ করছে তা নিশ্চিত করতে অনুগ্রহ করে অ্যাপটি আপডেট করুন।",
          title: "ইন্সটল করার নির্দেশাবলী"
        },
        block_two: {
          description: "{platform} অ্যান্ড্রয়েড মোবাইল অ্যাপ হলো আরো উন্নত গ্যাম্বলিং ও স্পোর্টস বেটের জগতে আপনার নির্দেশক। কোথা থেকে ডাউনলোড করতে হবে? অ্যান্ড্রয়েড মোবাইল মার্কেটপ্লেস যেমন গুগল প্লে মার্কেট, AppGallery বা অন্য যেকোনো অনুরূপ অ্যাপ শপের গ্যাম্বলিং-এর ক্ষেত্রে নির্দিষ্ট নীতিমালা থাকে। সেখানে আপনি শুধুমাত্র তৃতীয় পক্ষের ডেভেলপারদের পাবেন। অফিসিয়াল Olymp Casino সাইটের সাথে তাদের কোনো সম্পর্ক নেই। আসল অ্যাপটি খুঁজে পেতে আপনাকে আপনার কম্পিউটার বা মোবাইল ডিভাইসে প্রধান সাইট olymp.casino-তে যেতে হবে।",
          title: "অ্যাপটি কোথা থেকে ডাউনলোড করবেন"
        }
      },
      ios: {
        block_one: {
          description: "আইফোন ও আইপ্যাড মালিকদের মধ্যে {platform} গ্যাম্বলিং-এর অনেক ভক্ত রয়েছে। iOS অপারেটিং সিস্টেমের ডিভাইসগুলোর জন্য আমাদের যে মোবাইল অ্যাপটি আছে তাতে ব্যবহারকারীদের ক্ষেত্রে বিস্তৃত সুযোগ রয়েছে এবং খেলার ক্ষেত্রে সম্পূর্ণ স্বাধীনতা প্রদান করা হয়। সবসময় আপনার পকেটে সম্পূর্ণ অনলাইন ক্যাসিনো কার্যকারিতাসহ বিনোদনের একটি বিশাল ক্যাটালগ থাকে। অর্থ জমা করুন, আপনার প্রোফাইলের তথ্য পরিচালনা করুন, যেকোনো আকারের পুরস্কার ক্যাশ আউট করুন, অনলাইনে খেলুন এবং প্রতিদিন নতুন নতুন জিনিস চেষ্টা করুন। iOS-এর জন্য Olymp Casino মোবাইল অ্যাপটি, আপনি যতটা আনন্দ ও সুবিধা পেতে চান তা অর্জনে আপনাকে সাহায্য করবে! এটি করার জন্য, আপনাকে আপনার ফোন বা ট্যাবলেটকে সঠিকভাবে \"সজ্জিত\" করতে হবে এবং বিনোদন গ্রহণের দিকে এগিয়ে যেতে হবে।",
          title: "আইফোনের জন্য iOS Olymp Casino অ্যাপ"
        },
        block_three: {
          description: "iOS ডিভাইসের জন্য Olymp ক্যাসিনো অ্যাপ আপনাকে একটি প্ল্যাটফর্মেই গ্যাম্বলিং-এর সম্পূর্ণ কালেকশনে সম্পূর্ণ অ্যাক্সেস দেয়, যার মধ্যে আছে - অসংখ্য স্লট, টেবিল, স্পোর্টস এবং ক্র্যাশ গেম, টেবিল, লটারি, প্রোমোশন, টুর্নামেন্ট। মোবাইল অ্যাপে আপনার ব্যক্তিগত অ্যাকাউন্টের মাধ্যমে, আপনি নিম্নলিখিত যেকোনো প্রয়োজনীয় ক্রিয়া সম্পাদন করতে পারেন:",
          list: {
            five: "লেনদেনের ইতিহাস দেখা — সকল উত্তোলনের অর্ডার, লেনদেন ও বেট।",
            four: "ক্যাসিনো থেকে আসা ম্যাসেজ পড়ুন।",
            one: "প্রোফাইলের ব্যক্তিগত তথ্য পরিবর্তন করা এবং যাচাইকরণ পাস করা।",
            three: "নতুনদের জন্য একটি ওয়েলকাম বোনাসসহ - গিফট গ্রহণ, সক্রিয়করণ এবং বাজি ধরা।",
            two: "আপনার অ্যাকাউন্টে অর্থ জমা করুন, আপনার জয়ের অর্থ ক্যাশ আউট করুন এবং ইনস্ট্যান্ট ক্যাশব্যাক পান।"
          },
          text: "বিশেষত মোবাইল অ্যাপ ব্যবহারকারীদের জন্য অনেক ইউনিক অফার রয়েছে: সকল ইভেন্টের সাথে আপ টু ডেট থাকতে এবং সময়মত লাভজনক প্রোমোশন, বর্তমান ড্র ও এক্সক্লুসিভ টুর্নামেন্ট সম্পর্কে জানতে নোটিফিকেশন চালু করতে ভুলবেন না। অর্থ জমা করার, বাজি রাখার, স্লট মেশিন «পরীক্ষা» করার এবং আপনার ভাগ্যকে পরখ করার সময়। আমরা নিশ্চিত করেছি যে Olymp ক্যাসিনো অ্যাপের প্রতিটি ভার্চুয়াল সেশন আপনাকে শুধুমাত্র আনন্দদায়ক অভিজ্ঞতাই প্রদান করবে।",
          title: "কার্যকারিতা এবং বৈশিষ্ট্য"
        },
        block_two: {
          description: "আমরা জানি কীভাবে ব্যবহারকারীদের জন্য দক্ষতার সাথে ও আরামদায়কভাবে গেমের জন্য প্রয়োজনীয় সরঞ্জামগুলো সরবরাহ করতে হয়। {platform} মোবাইল অ্যাপ অ্যাপল স্টোরে পাওয়া যায় - বিনামূল্যে। iOS-এর জন্য অফিসিয়াল Olymp অ্যাপ ডাউনলোড করতে হলে আপনাকে অ্যাপ স্টোর থেকে একটি ডাউনলোড লিংক নিতে হবে। এটি করার দুটি পদ্ধতি রয়েছে - আপনি অধিক সুবিধাজনকটি বেছে নিতে পারেন:",
          list: {
            one: "আপনার কম্পিউটারে অফিসিয়াল Olymp ক্যাসিনো সাইটটি চালু করে মোবাইল অ্যাপের লিংক থাকা পেজে যান। সেখানে আপনি একটি QR কোড দেখতে পাবেন - আপনার ডিভাইসের ক্যামেরা এটির দিকে নিন এবং ডাউনলোড লিংকে ক্লিক করুন।",
            two: "আপনার iOS ডিভাইসের মাধ্যমে সরাসরি {platformSite} পোর্টালে যান — মোবাইল সংস্করণ খুলবে। আইফোন বা আইপ্যাডে Olympus অ্যাপ্লিকেশন ডাউনলোড করতে হলে শুধু \"iOS-এর জন্য ইন্সটল করুন\" বাটনে ক্লিক করুন। আপনাকে অ্যাপ স্টোরে পাঠানো হবে এবং আপনি অ্যাপটি ইন্সটল করা শুরু করতে পারেন।"
          },
          text: "ডাউনলোড সম্পন্ন হয়ে গেলে আপনি সিস্টেমে একটি অ্যাকাউন্ট তৈরি করতে পারেন বা আপনার যদি ইতোমধ্যে একটি ব্যক্তিগত অ্যাকাউন্ট থাকে তবে লগ ইন করতে পারেন এবং সবচেয়ে আকর্ষণীয় অংশ - {platform} বিনোদনে যেতে পারেন!",
          title: "অ্যাপটি ইন্সটল করা সহজ"
        }
      }
    },
    seoText: "আইফোনের পেজে বিশেষ কোনো SEO টেক্সটের প্রয়োজন নাও হতে পারে, তবে আপনি অ্যাপটির রিভিউ লেখার চেষ্টা করতে পারেন এবং \"olimpbet app review\" ক্যাটাগরির জন্য অপ্টিমাইজ করতে পারেন। এখানে প্রায় কোনো ফ্রিকোয়েন্সিই নেই।",
    seoTitle: "SEO টেক্সট",
    slider: {
      textEight: "সাইটে \"অ্যাপ ডাউনলোড করুন\" বাটনে ক্লিক করুন",
      textFive: "\"ইন্সটল\" বাটনে ক্লিক করুন",
      textFour: "অ্যাপের ডাউনলোডকৃত ফাইলটিতে ক্লিক করুন",
      textOne: "ডাউনলোড শুরু করতে \"ডাউনলোড করুন\" বাটনে ক্লিক করুন",
      textSeven: "আপনার ফোনের ক্যামেরাটি QR কোডের দিকে নিন এবং সাইটে যান",
      textSix: "আপনার ডেস্কটপ থেকে অ্যাপটি চালু করুন এবং খেলুন",
      textThree: "অজানা উৎস থেকে অ্যাপ ইন্সটল করার অনুমতি দিন",
      textTwo: "\"অজানা অ্যাপ ইনস্টল করা হচ্ছে\" সেকশনে যান"
    },
    slides: {
      allowInstall: "অজানা উৎস থেকে ইন্সটল করার অনুমতি দিন",
      cancel: "বাতিল করুন",
      download: "ডাউনলোড করুন",
      downloadApp: "অ্যাপ ডাউনলোড করুন",
      downloadIsDone: "ডাউনলোড সম্পন্ন হয়েছে",
      installUnknownApp: "অজানা অ্যাপ ইন্সটল করা হচ্ছে",
      isntall: "ইন্সটল করুন",
      moveToSite: "সাইটে যান",
      myFiles: "আমার ফাইলসমূহ",
      safeDescription: "প্লে মার্কেটের বাইরের অ্যাপ ইন্সটল করা। শুধুমাত্র বিশ্বস্ত উৎস থেকে ফাইল ডাউনলোড করুন",
      settings: "সেটিংস"
    },
    textForMobile: {
      androidAndIos: "অ্যান্ড্রয়েড এবং iOS-এর জন্য",
      downloadOnAndroid: "অ্যান্ড্রয়েডের জন্য ডাউনলোড করুন",
      downloadOnAndroidAndIos: "অ্যান্ড্রয়েড এবং iOS-এর জন্য ডাউনলোড করুন",
      downloadOnIos: "iOS-এর জন্য ডাউনলোড করুন",
      onAndroid: "অ্যান্ড্রয়েডের জন্য",
      onIos: "iOS-এর জন্য"
    },
    title: "Olymp অ্যাপ"
  },
  Aviator: "এভিয়েটর",
  Basket: "বেট স্লিপ",
  BeforeEndPromotion: "প্রমোশন শেষ না হওয়া পর্যন্ত",
  BeforeStartPromotion: "প্রমোশন শুরুর আগে",
  Betgames: "বেটগেমস",
  Bets: "অড্ডস",
  BonusBalanceOff: "আপনি মূল ক্যাসিনো ব্যালেন্সে স্যুইচ করেছেন। আপনার অ্যাকাউন্টে অর্থ জমা করুন এবং আপনার প্রিয় গেম খেলুন।",
  BonusBalanceOn: "আপনি বোনাস ক্যাসিনো ব্যালেন্সে স্যুইচ করেছেন।",
  BonusesAndPromotions: "বোনাস এবং প্রচার",
  BonusesAndPromotionsSection: "বোনাস এবং প্রচার বিভাগ",
  Categories: "ক্যাটাগরি সমূহ",
  Chat: "চ্যাট",
  CloseMatchTracker: "ম্যাচ ট্র্যাকার বন্ধ করুন",
  CoefficientChanged: "অডস পরিবর্তিত হয়েছে",
  ContactSupport: "সাপোর্টের সাথে যোগাযোগ করুন",
  "Cricket X": "ক্রিকেট X",
  DeleteConfirm: "মুছে ফেলা নিশ্চিত করুন",
  DeleteConfirmText: "আপনি কি সত্যিই পূর্বে আপলোড করা ফাইল মুছে ফেলতে চান?",
  DeleteFiles: "ফাইল মুছে দিন",
  DenyReason: "কোন কারণে প্রত্যাখ্যাত",
  DocumentAlreadyAttached: "এই ফাইলটি ইতিমধ্যে সংযুক্ত আছে",
  DocumentDoesntMeetRequirements: "নথিটি প্রয়োজনীয়তা পূরণ করে না",
  DocumentResolutionTooBig: "ছবির রেজোলিউশন খুব বেশি। সর্বোচ্চ সমর্থিত রেজোলিউশন - {value} মেগা পিক্সেল",
  DocumentsFilesLimits: "(সর্বোচ্চ ফাইল সংখ্যা - {fields}, সর্বোচ্চ ফাইলের আকার - {size} এমবি)",
  DocumentsUploadError: "ফাইল আপলোড করার সময় একটি ত্রুটি ঘটেছে - {files}। বাকি ফাইলগুলো পর্যালোচনার জন্য পাঠানো হয়েছে। আপনি এই ফাইলগুলি আবার ডাউনলোড করার চেষ্টা করতে পারেন",
  DownloadOn: "ডাউনলোড করুন",
  EuroLanding: {
    activate: "<span>সক্রিয় করুন</span><br  /> “বোনাস” সেকশান এ",
    bonusText: "<span>ফ্রিবেট</span><b>{freebet}</b><span>রেজিস্ট্রেশনের জন্য!</span>",
    register: "<span>নিবন্ধন </span><br /> Olymp Casino ওয়েবসাইট এ"
  },
  Event: "ইভেন্ট",
  Exclusive: "এক্সক্লুসিভ",
  Expires: "মেয়াদ শেষ",
  ForbidenBonus: "বর্তমান দিনের জন্য পুরস্কার ইতিমধ্যে পাওয়া গেছে",
  Found: "পাওয়া গেছে",
  FruityWheel: {
    btn: "স্পিন করুন",
    title: "স্পিন করে আপনার ওয়েলকাম বোনাস পেয়ে যান"
  },
  GatesOfOlympus: {
    completeSignIn: "এখনই নিবন্ধন সম্পন্ন করে বোনাস পেয়ে যান",
    getBonus: "বোনাস পান",
    spin: "ঘুরান",
    titleFirstLine: "হুইল ঘুরান",
    titleSecondLine: "বোনাস পান",
    twist: "স্পিন করুন",
    youWin: "আপনি জিতেছেন",
    yourBonus: "আপনার বোনাস"
  },
  GetYourPrizes: " উপহার গ্রহণ করুন আপনার",
  GoldenTimesKz: {
    bonusText: "অভিনন্দন! আপনার জয়",
    headTitle: "আপনার বোনাস দাবি করুন <br /> এবং জ্যাকপট হিট করুন!",
    labelText: "আপনার ফোন নম্বর লিখুন"
  },
  InformationAllPromotions: "সমস্ত প্রচারের তথ্য",
  InitialCoefficient: "প্রাথমিক ওডস:",
  JetX: "JetX",
  LongTermRates: "দীর্ঘমেয়াদী বেট",
  MainSite: "প্রধান সাইট",
  MatchTracker: "ম্যাচ ট্র্যাকার",
  MaximizeMatchTracker: "ম্যাচ ট্র্যাকার বড় করুন",
  MinimizeMatchTracker: "ম্যাচ ট্র্যাকার হ্রাস করুন",
  Mobile: "মোবাইল",
  MobileAppSetupLanding: {
    app: "/অ্যাপ",
    appText: "মেনু বিকল্প /অ্যাপ নির্বাচন করুন",
    getLink: "অথবা আমাদের টেলিগ্রাম বটের মাধ্যমে লিঙ্কটি পানঃ ",
    getLinkButton: "লিঙ্ক টি পান",
    groups: {
      four: "সমস্ত ইভেন্ট এবং প্রচারের বিজ্ঞপ্তি পেয়ে <br/> আপডেট থাকুন",
      one: "<span>ডিপোজিট ছাড়াই 100 FS </span> মোবাইল অ্যাপের ইনস্টলেশন এ",
      three: "এক্সক্লুসিভ <br/> প্রচার এবং টুর্নামেন্ট",
      two: "<br/> মিরর সাইট অনুসন্ধান করার প্রয়োজন নেই"
    },
    start: "/আরম্ভ",
    startText: "ট্যাপ করে টেলিগ্রাম বট চালু করুন/শুরু করুন ",
    successLink: "লিঙ্ক সফলভাবে পাঠানো হয়েছে",
    text: "Olymp মোবাইল অ্যাপ ডাউনলোড করুন এবং যেকোনো সময় খেলার জন্য প্রস্তুত থাকুন",
    title: "OLYMP মোবাইল অ্যাপ ইনস্টল করার জন্য <br/>ডিপোজিট </span> ছাড়াই 100 FS<span>"
  },
  MobileApplications: "মোবাইল অ্যাপ্লিকেশন",
  MyDocuments: "আমার ডকুমেন্টগুল",
  NewYearRules: {
    "1": "প্রচারের সময়কাল: ডিসেম্বর: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +5",
    "10": "Aviator  ফ্রিবেটস",
    "11": "JetX ফ্রিবেটস",
    "12": "আপনি প্রোমো পৃষ্ঠায় একটি বোনাস জিতলে, \"বোনাসে যান\" বোতামে ক্লিক করে বোনাসটি আপনার ব্যক্তিগত অ্যাকাউন্টে, \"বোনাস\" বিভাগে যোগ করা হবে।",
    "13": "যোগ করা বোনাস সক্রিয়করণ ৩ দিনের মধ্যে উপলব্ধ",
    "14": "অ্যাক্টিভেশনের পরে, জমা দিতে হবে 1 দিনের মধ্যে",
    "15": "বোনাস আমউন্ট এর বাজি 1 দিনের মধ্যে সম্পন্ন করতে হবে",
    "16": "প্রতিটি বোনাসের জন্য বিস্তারিত শর্ত আপনার ব্যক্তিগত অ্যাকাউন্টের \"বোনাস\" পৃষ্ঠায় পাবেন",
    "2": "প্রোমো সেকশান এ  প্রতিদিন আপনাকে বোনাস পাওয়ার জন্য ৩ বার অপশান দেওয়া হবে।",
    "3": "00:00 GMT +5 তে প্রচারের সময়কালে প্রতিদিন 3 বার রিসেট করার সুযোগ থাকবে।",
    "4": "বোনাস জেতার জন্য , ব্যবহারকারীকে প্রতিদিন প্রচার পৃষ্ঠায় যেতে হবে এবং স্পিন বোতামে ক্লিক করে স্লট মেশিন চালু করতে হবে",
    "5": "স্পিন এর প্রতিটি প্রেসে একটি প্রচেষ্টা প্রয়োজন।",
    "6": "বোনাস জেতা ও বোনাস ওয়ে ধরণ এলোমেলোভাবে নির্ধারিত হয়:",
    "7": "স্লটে জমার উপর বোনাস",
    "8": "স্লটে বিনামূল্যে স্পিন",
    "9": "খেলাধুলার জন্য ফ্রিবেটস"
  },
  NezlobLanding: {
    forDeposit: "জমার উপর",
    title: "রসিকতা শেষ!"
  },
  NotCalculated: "গণনা করা হয়নি",
  NotSingleActionCurrentlyHeld: "এখন কোন প্রচার চলছে না",
  OlimpCasino: "Olymp ক্যাসিনো",
  OpenFullVersion: "সম্পূর্ণ ভার্শন টি খুলুন",
  PaymentMethods: "অর্থপ্রদানের পদ্ধতি",
  PlayEveryDay: "প্রতিদিন খেলুন",
  PromoAvailableFrom: "প্রচারটি {date} থেকে উপলব্ধ",
  PromoAvailableFromTo: "প্রচারটি {date1} থেকে {date2} পর্যন্ত উপলব্ধ",
  PromoEnded: "প্রচারটি {date} এ শেষ হয়েছে",
  Promotions: "প্রোমোশন",
  PromotionsWillDisplayedHere: "প্রচার এখানে প্রদর্শিত হবে",
  QuestionAndAnswer: "প্রশ্ন - উত্তর",
  RulesAcceptingBets: "অলিম্পিক বুকমেকারের কাছ থেকে বাজি গ্রহণের নিয়ম",
  RulesOfPromotion: "প্রোমোশন টি ও সিস",
  RulesSingle: "নিয়মাবলী",
  SelectTypeSystem: "আপনার সিস্টেমের ধরন নির্বাচন করুন",
  Soon: "শীঘ্রই",
  Statistics: "পরিসংখ্যান",
  StayTuned: "সাথে থাকুন",
  TableContents: "বিষয়বস্তু টেবিল",
  TheSearchHasNotGivenAnyResults: "অনুসন্ধান করে কোন ফলাফল পাওয়া যায়নি",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "নিষ্ক্রিয়/ বিচ্ছিন্ন করতে আপনাকে আপনার ফোন এবং ই-মেইল নিশ্চিত করতে হবে।",
  ToMain: "বাড়ি",
  ToUp: "শীর্ষে",
  TypeBonusesAndPromotions: "বোনাস এবং প্রচারের প্রকার",
  UntilTheNextBonus: "পরবর্তী বোনাস পর্যন্ত",
  UploadDocuments: "ডাউনলোড করা ফাইল",
  Version: "সংস্করণ",
  WeAreOnSocialMedia: "আমরা সোশ্যাল মিডিয়া এ আছি",
  WeOnSocialMediaFull: "আমরা সোশ্যাল মিডিয়া এ আছি",
  WorldCup: "2022 বিশ্বকাপ",
  YouDataProtected: "ব্যক্তিগত তথ্য এবং তহবিল নিরাপদ",
  YourBonus: "আপনার বোনাস",
  aboutBonus: "বোনাস সম্পর্কে আরো তথ্য",
  acceptWithModifiedOdds: "আপডেট হওয়া অডস সহ গ্রহণ করুন",
  acceptWithModifiedTotals: "আপডেট হওয়া টোটাল/হ্যান্ডিক্যাপ সহ গ্রহণ করুন",
  accountApprove: "অ্যাকাউন্ট সুরক্ষিত",
  accountNotApprove: "অ্যাকাউন্ট সুরক্ষিত নয়",
  action: "অ্যাকশন",
  activate: "সক্রিয় করুন",
  activateBonus: "বোনাস সক্রিয় করুন",
  activateFastBets: "কুইক বেট সক্রিয় করুন",
  activatingPromoCode: "প্রোমোকোড সক্রিয়করণ",
  active: "সক্রিয়",
  activeBonusErr: "একটি বোনাস সক্রিয় করতে, অন্তত যে পরিমাণ অর্থ জমা করতে হবে",
  activeWager: "বাজি সক্রিয় করুন",
  add: "যোগ করুন",
  addToBasket: "বাজি স্লিপে যোগ করুন\n",
  addYourFavoriteGames: "পছন্দের তালিকায় এই গেমটি যোগ করুন",
  addingDogeCoin: "Doge যোগ করা হচ্ছে",
  additionalInfo: "অতিরিক্ত ডেটা",
  addressCryptoWallet: "Crypto wallet address",
  addressWallet: "ওয়ালেটের ঠিকানা",
  afterInstallApp: "অ্যাপটি ইনস্টল করার জন্য আপনি একটি বোনাস {0} পেয়েছেন",
  agreeTermsAndConditions: "আমি {0} এর সাথে একমত এবং নিশ্চিত করছি যে আমার বয়স 18 বছরের বেশি",
  all: "সকল",
  allDepositMethods: "জমার সকল পদ্ধতি",
  allGames: "সকল গেম",
  allMessages: "টোটাল",
  allMessagesButton: "ম্যাসেজে যান",
  allMessagesText: "সকল ম্যাসেজ",
  allPromo: "সকল প্রোমোশন",
  allRequiredFieldsMustBeFilled: "প্রয়োজনীয় ঘরগুলো পূরণ করতে হবে",
  allTypes: "সব ধরনের",
  allWithdrawMethods: "অর্থ উত্তোলনের সকল পদ্ধতি",
  all_right: "সর্বস্বত্ব সংরক্ষিত।",
  alreadyHasAccount: "অ্যাকাউন্ট ইতোমধ্যেই বিদ্যমান",
  always: "সর্বদা",
  amountOnAccount: "অ্যাকাউন্টে অর্থের পরিমাণ",
  anUnexpectedErrorOccurred: "একটি অপ্রত্যাশিত ত্রুটি ঘটেছে!",
  antifraud: {
    five: "একাধিক স্তরে গ্রাহক পরীক্ষা (আইপি-এর মাধ্যমে চেক, সিস্টেম প্যারামিটার চেক, প্রক্সি চেক); গ্রাহকের ফোন নম্বর যাচাইকরণ; বিশেষজ্ঞ দ্বারা প্লেয়ারের আচরণের বিশ্লেষণ; প্রতারণা বিরোধী সিস্টেমে 100টিরও বেশি ফিল্টার রয়েছে যা পেমেন্টের ডেটা, পেমেন্টের ইতিহাস এবং ব্যবহারকারীর ব্ল্যাকলিস্টের বিস্তারিত যাচাইয়ের জন্য ডিজাইন করা হয়েছে; গ্রাহক অর্থ উত্তোলনের স্তরে আমাদের নিয়ন্ত্রণ পরিষেবা দ্বারা চূড়ান্ত যাচাইকরণের মধ্য দিয়ে যায়।",
    four: "প্রধান বৈশিষ্টসমূহ",
    one: "জালিয়াতি থেকে সুরক্ষা",
    three: "অনলাইন পেমেন্ট পরিষেবার নেতৃস্থানীয় পরিষেবা প্রদানকারীদের সহযোগিতায়, আমরা বিশ্বস্তভাবে অনলাইন ব্যবসা পরিচালনা করতে এবং আমাদের ব্যবহারকারীর ব্যক্তিগত তথ্যের পাশাপাশি সকল পেমেন্টের ডেটার নিরাপত্তা নিশ্চিত করার জন্য যথাসাধ্য চেষ্টা করি। পেমেন্ট লেনদেনের ডাটাবেস পরিচালনায় আমাদের দশ বছরের অভিজ্ঞতা Avento AntiFraud Tool-কে ক্রেডিট কার্ড জালিয়াতির বিরুদ্ধে একটি সত্যিকারের শক্তিশালী এবং সুবিধাজনক টুলে পরিণত করেছে।",
    two: "Avento AntiFraud Tool প্রতারণামূলক অনলাইন গ্যাম্বলিং লেনদেন প্রতিরোধ করার জন্য ডিজাইন করা একটি শক্তিশালী অ্যান্টি-ফ্রড টুল। এটির সাহায্যে আমরা গ্যাম্বলিং প্রতিষ্ঠানে ক্রেডিট কার্ড জালিয়াতির সংখ্যা উল্লেখযোগ্য পরিমাণে হ্রাস করতে সক্ষম হয়েছি।"
  },
  app: "অ্যাপ্লিকেশন",
  appOlymp: "Olymp অ্যাপ",
  apply: "আবেদন করুন",
  approve: "আমি নিশ্চিত করছি",
  approvePhoneBySms: "SMS-এর মাধ্যমে নম্বর নিশ্চিত করুন",
  approvePhoneByTelegram: "টেলিগ্রামের মাধ্যমে নম্বর নিশ্চিত করুন",
  approved: "অনুমোদিত",
  approvedSecond: "নিশ্চিত করা হয়েছে",
  approvingWithdraw: "অর্থ উত্তোলন কনফার্মেশন",
  april: "এপ্রিল",
  areYouSureDeposit: "আপনি কি নিশ্চিত যে আপনি টাকা জমা করেছেন?     ",
  areYouSureToDeclineBonus: "আপনি কি বোনাস বাতিল করার বিষয়ে নিশ্চিত?",
  areYouSureYouWantToSell: "আপনি কি নিশ্চিত আপনি আপনার বেট নগদ করতে চান",
  attach: "ডকুমেন্ট সংযুক্ত করুন",
  attachDocumentsToVerifyAccount: "যাচাইকরণ সম্পন্ন করতে এবং অর্থ উত্তোলনের জন্য অনুগ্রহ করে ডকুমেন্ট সংযুক্ত করুন",
  attempt: "কোন প্রচেষ্টা নয় | 1 প্রচেষ্টা | {count} প্রচেষ্টাশমুহ",
  august: "আগস্ট",
  authApproveText: "আপনি যে রোবট নন তা যাচাই করতে 'নিশ্চিত করুন' বোতামে ক্লিক করুন\n",
  authFromSocial: "সামাজিক নেটওয়ার্কের ব্যবহার করে লগ ইন করুন",
  authorization: "অনুমোদন",
  authorizationRequired: "পেইড গেমের জন্য অনুমোদন প্রয়োজন হয়!",
  availabilityWallet: "ক্রিপ্টো ওয়ালেট {wallet} প্রয়োজন",
  available: "উপলব্ধ",
  availableBonuses: "এভেইলেবল বোনাস",
  availableOnlyGameForMoney: "শুধুমাত্র অর্থের জন্য খেলা এভেইলেবল",
  back: "ফিরে যান",
  backToHome: "প্রধান পেজে ফিরে যান",
  backToLogin: "লগইন-এ ফিরে যান",
  backToOneStep: "ধাপ এক-এ ফিরে যান",
  balance: "ব্যালেন্স",
  balanceAfterTopUp: "অর্থ জমার পরে ব্যালেন্স: {value}",
  balanceAfterWithdraw: "অর্থ উত্তোলনের পরে ব্যালেন্স: {value}",
  balanceBK: "বুকমেকারের ব্যালেন্স",
  balanceBKRefreshSuccessfully: "বুকমেকারের ব্যালেন্স সফলভাবে আপডেট করা হয়েছে",
  balanceCasino: "ক্যাসিনোর ব্যালেন্স",
  balanceCasinoRefreshSuccessfully: "ক্যাসিনোর ব্যালেন্স সফলভাবে আপডেট করা হয়েছে",
  balanceSwitchByWithoutBalance: "বোনাস ব্যালেন্সে স্যুইচ করা শুধুমাত্র বোনাস গেম খেলার সময় স্বয়ংক্রিয়ভাবে সম্পন্ন হয়, যদি প্রকৃত ব্যালেন্সে কোন তহবিল না থাকে",
  balances: "ব্যালেন্স",
  bankCard: "ব্যাংক কার্ড",
  basketBets: "বেট স্লিপ",
  behind: "কিসের জন্য",
  bet: "বেট",
  betHistory: "বেট",
  betID: "বেট আইডি",
  betSoldFor: "{count}-এর জন্য বেট ক্যাশ আউট করা হয়েছে",
  betsAreSuspended: "বেটিং স্থগিত করা হয়েছে",
  betsNotAccessForBonusBalance: "বোনাস ব্যালেন্স দিয়ে স্পোর্টস বেটিং করা যায় না!",
  bettingHistory: {
    bet: "বাজি",
    coefficient: "ওডস",
    dataOfBet: "বাজির তথ্য",
    findOutTheScore: "স্কর খুজে বের করুন",
    numberAndDateOfBet: "বাজি নাম্বার ও তারিখ",
    payout: "পেয়াউট",
    status: "স্টেটাস"
  },
  bidAddedToCart: "বেট স্লিপে বাজি যোগ করা হয়েছে ৷",
  bidDeletedToCart: "বেট স্লিপ থেকে বাজি সরানো হয়েছে ৷",
  bonus: "বোনাস",
  bonusActivated: "বোনাস সক্রিয় করা হয়েছে",
  bonusActivation: "বোনাস সক্রিয়করন",
  bonusBalance: "বোনাস ব্যালেন্স",
  bonusBalanceOnly: "বোনাস ব্যালান্স থেকে খেলতে, বোনাস গেম চালু করুন",
  bonusCondition: "বোনাসের শর্তাবলী",
  bonusNotActivated: "বোনাস সক্রিয় করা হয়নি",
  bonusOnFirstDeposit: "বোনাস 100 %<br/ প্রথম আমানতের জন্য",
  bonusQuestion: "এখনো আপনার ওয়েলকাম বোনাস পাননি?",
  bonusSport: {
    block1: {
      li1: "Olymp.casino-এ নিবন্ধন করুন।",
      li2: "বোনাস সক্রিয় করতে আপনার ব্যক্তিগত অ্যাকাউন্টের \"বোনাস\" সেকশনে গিয়ে অফারটি সক্রিয় করুন।",
      li3: "একটি পেমেন্টে 500 KZT / 12 000 UZS থেকে শুরু করে যেকোনো পরিমাণে অর্থ জমা করুন।",
      li4: "অর্থ জমা করার পরে, বোনাসটি স্বয়ংক্রিয়ভাবে জমা হবে এবং আপনার কুপনের \"স্পোর্টস\" সেকশনে বেট ধরার জন্য এভেইলেবল হবে।",
      title: "কীভাবে আপনার বোনাস পাবেন:"
    },
    block2: {
      li1: "ব্যবহারকারীরা শুধুমাত্র একবার বোনাস পাওয়ার অধিকার রাখেন।",
      li2: "ফ্রি বেট শুধুমাত্র স্পোর্টস-এ ব্যবহার করা যেতে পারে। আপনার বেট স্লিপটি অবশ্যই একটি একক বেট হতে হবে যার অডস সর্বনিম্ন 3 ও সর্বোচ্চ 10-এর মধ্যে।",
      li3: "প্লেয়ার তার অ্যাকাউন্টে শুধুমাত্র বাজি থেকে জয়ের অংশটি পান।",
      text: "উদাহরণস্বরূপ: 3 অডসের 500-এর একটি ফ্রি বেট। প্লেয়ার অ্যাকাউন্টে 3*500-500 = 1000 পাবেন।",
      title: "শর্তাবলী:"
    },
    block3: {
      li1: "ফ্রি বেটের বাজির শর্ত অবশ্যই 7 দিনের মধ্যে পূরণ করতে হবে, অন্যথায় বোনাসের মেয়াদ শেষ হয়ে যাবে।",
      li10: "Olymp.casino-এর অফারটির শর্তাবলী পরিবর্তন করার, অফারটি বাতিল বা নবায়ন করার বা পূর্ব ঘোষণা ছাড়াই যেকোনো সময়ে অংশগ্রহণ প্রত্যাখ্যান করার অধিকার রয়েছে।",
      li11: "Olymp.casino এই অফার বা অন্য কোনো অফারে ব্যবহারকারীদের অংশগ্রহণ সীমিত বা অস্বীকার করতে পারে।",
      li12: "ইমেইল ঠিকানা, ব্যাংক অ্যাকাউন্টের বিবরণ, ক্রেডিট কার্ডের তথ্য ও পেমেন্ট সিস্টেম অ্যাকাউন্টসহ প্রতি গ্রাহক, পরিবার, ঠিকানা, শেয়ার্ড কম্পিউটার, শেয়ার্ড আইপি ঠিকানা এবং যেকোনো অভিন্ন অ্যাকাউন্ট ডেটার জন্য শুধুমাত্র একটি বোনাস অনুমোদিত। এই বোনাস অফারের কোনো অপব্যবহার করলে অ্যাকাউন্ট বন্ধ হয়ে যাবে।",
      li13: "Olymp.casino যেকোনো সময় এই অফারটি পরিবর্তন বা বাতিল করার অধিকার সংরক্ষণ করে।",
      li14: "বোনাস গ্রহণ করার মাধ্যমে গ্রাহক বোনাসের শর্তাবলীর পাশাপাশি Olymp.casino-এর সাধারণ শর্তাবলীতে সম্মতি প্রকাশ করেন।",
      li2: "জয়ের অর্থ উত্তোলন করতে হলে আপনাকে ন্যূনতম 500 KZT/12,000 UZS জমা করতে হবে এবং 1 বার বাজি ধরতে হবে।",
      li3: "বাতিল বা রিফান্ডের ক্ষেত্রে বেটটি লোকসান হিসেবে নিষ্পত্তি করা হয়।",
      li4: "অর্ধ-লোকসানের ক্ষেত্রে (এশিয়ান হ্যান্ডিক্যাপ এবং টোটাল) - বেট লোকসান হিসেবে নিষ্পত্তি করা হয়।",
      li5: "অর্ধেক জয়ের ক্ষেত্রে (এশিয়ান হ্যান্ডিক্যাপ এবং টোটাল) - বেটের পরিমাণ বাদ দিয়ে নিয়মিত বেট হিসেবে নিষ্পত্তি করা হয়।",
      li6: "বেট নিষ্পত্তি হওয়ার পরে, টাকা আপনার ব্যালেন্সে যোগ করা হয়।",
      li7: "ফ্রি বেট আংশিক ব্যবহার করা যাবে না। (অর্থাৎ যদি আপনার 500-এর উপর একটি ফ্রি বেট থাকে, তাহলে আপনাকে অবশ্যই 500-এ বাজি ধরতে হবে। বিভিন্ন কুপনের জন্য 250 - 250 গ্রহণ করা হয় না)।",
      li8: "অফারকে অন্যান্য প্রোমোশনাল বা স্পেশাল অফারের সাথে একত্রে ব্যবহার করা যাবে না।",
      li9: "একাধিক অ্যাকাউন্ট অনুমোদিত নয় এবং একাধিক অ্যাকাউন্ট পাওয়া গেলে পুরো অ্যাকাউন্ট বাতিল করা হবে।",
      title: "অন্যান্য শর্তাবলী:"
    },
    title: "Olymp.Casino-তে যোগদানের সেরা সময় এখন, কারণ আমরা প্রত্যেক নতুন ব্যবহারকারীকে স্পোর্টসের জন্য 500 KZT / 12 000 UZS ফ্রি বেট অফার করি"
  },
  bonusTimeLeft: "কাজ সম্পূর্ণ করার সময়",
  bonusWager: "বোনাস দিয়ে বাজি:",
  bonuses: "বোনাস",
  bookmakerShort: "বুকমেকার",
  "break": "বিরতি",
  bronze: "ব্রোঞ্জ",
  btn: "ক্যাশ ডেস্ক",
  byDefault: "গতানুগতিক",
  byDefaultDown: "বর্ণমালা অনুসারে (এ-জেড)",
  byDefaultUp: "বর্ণমালা অনুসারে (জেড -এ)",
  bySport: "স্পোর্টস অনুযায়ী",
  cabbage: {
    eight: "- যদি প্লেয়ার 5 দিনের পুরো সাইকেলটি সম্পন্ন করেন।",
    eighteen: "পুরস্কার {number}",
    eleven: "প্রোমোতে অংশগ্রহণ করে, আপনি নিজে থেকে এই অনলাইন ক্যাসিনোর শর্তাবলী মেনে নিচ্ছেন।",
    fifteen: "লক্ষ্য এবং পুরস্কার",
    five: "প্রতিদিনের অগ্রগতির ভিত্তিতে এবং একই দিনের মধ্যে আপনার লক্ষ্য অর্জন করার সাথে সাথে পুরস্কার বৃদ্ধি পায়। দৈনন্দিন অগ্রগতি বজায় রাখতে, সাইকেলের পরের দিনে অংশগ্রহণের জন্য এবং সম্ভাব্য বড় পুরস্কারের জন্য যোগ্য হতে প্লেয়ারকে অন্তত একবার সফলভাবে দৈনিক লক্ষ্য পূরণ করতে হবে।",
    four: "দৈনিক পুরস্কারের প্রোমোশন সাইকেলে পরিচালিত হয়, প্রতিটি সর্বোচ্চ 5 পঞ্জিকা দিবসের জন্য স্থায়ী হয়। এই সাইকেলের সময় অংশগ্রহণকারীদের দৈনিক লক্ষ্য 3 বার পর্যন্ত সম্পন্ন করার সুযোগ থাকে।",
    fourteen: "ত্রুটি ঘটলে সকল পে ও খেলা অকার্যকর হয়ে যায়।",
    list: "নিয়মাবলী:",
    nine: "একটি স্পিন করার জন্য মূল্য ছাড়া, অংশগ্রহণ ও পুরস্কার গ্রহণ করার জন্য কোনো অতিরিক্ত খরচ নেই।",
    nineteen: "দৈনিক লক্ষ্য একবার সম্পন্ন হয়েছে",
    one: "এখন মুনাফা নেওয়ার সময়।",
    seven: "- প্লেয়াররা যদি একটি দিন মিস করেন বা অন্তত একবার দৈনিক লক্ষ্য পূরণ না করেন",
    seventeen: "দৈনিক লক্ষ্য",
    six: "2টি ক্ষেত্রে 1ম দিনে প্লেয়ারের দৈনিক পুরস্কার সাইকেল রিসেট হয়:",
    sixteen: "সাইকেলে দিন",
    ten: "শুধুমাত্র প্রকৃত অর্থ দিয়েই দৈনিক পুরস্কারে অংশগ্রহণ করা যাবে।",
    thirteen: "সাইকেলের বর্তমান অবস্থা অনুযায়ী কোনো অর্থপ্রদান ছাড়াই {company} অনির্দিষ্ট সময়ের জন্য দৈনিক পুরস্কারের প্রোমোশন বাতিল করার অধিকার সংরক্ষণ করে।",
    three: "প্রাইজ পুল: ব্যক্তিগত 1'160.00 ইউরো (একটি সর্বোচ্চ মোট ব্যক্তিগত প্রাইজ পুল হিসেবে হিসাব করা হয় যদি প্লেয়ার এই ক্যাম্পেইনের সময়কাল জুড়ে সকল সম্ভাব্য দৈনিক লক্ষ্য পূরণ করে (3টি সম্পূর্ণ সাইকেল))। সকল Booongo গেম অংশগ্রহণ করছে। প্রতিটি সাইকেলের শেষ দিনে অসাধারণ পুরস্কার আসছে!",
    twelve: "দৈনিক পুরস্কারের নিয়মাবলী যেকোনো সময় পরিবর্তন করা যেতে পারে।",
    twenty: "দৈনিক লক্ষ্য দুইবার সম্পন্ন হয়েছে",
    twentyFive: "অংশগ্রহণকারী প্রতি সর্বোচ্চ 1160 ইউরো!",
    twentyFour: "পুরস্কারের অর্থ",
    twentyOne: "দৈনিক লক্ষ্য 3 বার সম্পন্ন হয়েছে",
    twentySix: "তারিখ ও সময়",
    two: "অংশ নিতে হলে Booongo-এর যেকোনো গেম খেলুন এবং আপনার দৈনন্দিন লক্ষ্যে পৌঁছান। পুরস্কারের অর্থ - অংশগ্রহণকারী প্রতি সর্বোচ্চ 1160 ইউরো!"
  },
  cabinet: "ব্যক্তিগত অ্যাকাউন্ট",
  calculated: "নিষ্পত্তিকৃত",
  calculationID: "নিষ্পত্তির আইডি",
  canNotChangeCurrency: "মুদ্রা পরিবর্তন করা যাবে না",
  canSelectSavedData: "আপনি সংরক্ষিত ডেটা নির্বাচন করতে পারেন",
  cancel: "বাতিল করুন",
  cancelBonus: "বোনাস বাতিল করুন",
  cancelBonusConfirm: "আপনি কি নিশ্চিত যে আপনি বোনাস বাতিল করতে চান? বাতিলের ক্ষেত্রে সমস্ত বোনাস তহবিল বাজেয়াপ্ত করা হবে।",
  cantEnterTheCode: "কোড লিখতে পারবেন না?",
  carriedOut: "সম্পন্ন করা",
  cashBackSum: "ইনস্ট্যান্ট ক্যাশব্যাকের পরিমাণ",
  cashBoxApproveCode: "কনফার্মেশন কোড",
  cashBoxApproveCodeHint: "ক্যাশিয়ার কর্তৃক অর্থ উত্তোলন নিশ্চিত করতে হবে",
  cashBoxDeliveryText: "আপনার সুবিধার জন্য, আপনার অর্থ জমা/উত্তোলনের পরিমাণ অন্তত {0} হলে, আপনি কুরিয়ারের জন্য অনুরোধ করতে পারবেন। কুরিয়ার চাওয়ার জন্য টেলিগ্রামে আমাদের সাথে যোগাযোগ করুন, লগইন করুন {1}",
  cashbackTitle: "ক্যাশব্যাক",
  cashboxAddress: "ক্যাশ-ডেস্কের ঠিকানা",
  casino: "ক্যাসিনো",
  casinoBonus: "ক্যাসিনোর বোনাস",
  casinoLogin: "{name} লগইন করুন",
  categoryFromAtoZ: "A থেকে Z পর্যন্ত ক্যাটাগরি",
  change: "পরিবর্তন করুন",
  changeData: "ডেটা পরিবর্তন করুন",
  changeEmail: "ইমেইল পরিবর্তন করুন",
  changeMethod: "পদ্ধতিটি পরিবর্তন করুন",
  changePassword: "পাসওয়ার্ড পরিবর্তন করুন",
  changePhone: "নম্বর পরিবর্তন করুন",
  changeStatusCode: "কোডের স্ট্যাটাস পরিবর্তন করুন",
  changeTheEmail: "ইমেইল পরিবর্তন করুন",
  changeWallet: "ওয়ালেট বদলান",
  changingEmail: "ইমেইল পরিবর্তন করুন",
  changingPhone: "নম্বর পরিবর্তন করুন",
  checkRobotText: "আপনি যে রোবট নন তা যাচাই করতে \"আমি নিশ্চিত করছি\" বোতামে ক্লিক করুন",
  checking: "চেক করা হচ্ছে",
  chooseComfortableAddress: "ভিজিট করার জন্য সুবিধাজনক একটি ঠিকানা চয়ন করুন",
  chooseDepositViaCryptocurrencyMethod: "\"ক্রিপ্টোকারেন্সি দ্বারা ডিপোজিট\" পদ্ধতি নির্বাচন করুন",
  chooseVariantOrContinueEnter: "একটি অপশন নির্বাচন করুন বা লেখা চালিয়ে যান",
  chooseVerificationMethod: "একটি কোড সহ প্রত্যাহার নিশ্চিতকরণ বন্ধ  করার জন্য একটি পদ্ধতি চয়ন করুন৷",
  clear: "ক্লিয়ার করুন",
  clearFavorites: "ফেভারিট ক্লিয়ার করুন",
  clickCheckoutInHeaderOfSite: "সাইটের শিরোনামে \"ক্যাশ ডেস্ক\" ক্লিক করুন",
  clickHome: "“হোম” এ ট্যাপ করুন",
  clickOnTheOddsYouLike: "আপনার পছন্দ মত বাজির গুণ ক্লিক করে, খুব সহজেই পপ-আপ উইন্ডোতে দ্রুত বাজি /কুইক বেট রাখুন:",
  clickSelectFrontCoin: "মুদ্রার পাশে \"সিলেক্ট\" ক্লিক করুন, উদাহরণস্বরূপ, “Tether TRC20\"",
  clickShare: "\"শেয়ার\" ক্লিক করুন",
  clickToAttache: "ফাইল সংযুক্ত করতে ক্লিক করুন",
  clickTopMenuToBuyCrypto: "উপরের মেনুতে \"ক্রিপ্টো কিনুন\"  এ ক্লিক করুন এবং \"ব্যাংক কার্ডের মাধ্যমে\" অর্থপ্রদানের পদ্ধতি নির্বাচন করুন। মিন পরিমাণ - 10.40 USD",
  close: "ক্লোজ করুন",
  code: "কোড",
  codeAlreadySendFillIt: "আমরা একটি কনফার্মেশন কোড পাঠিয়েছি, অনুগ্রহ করে এটি ইনপুট দেওয়ার ঘরে প্রবেশ করান।",
  codeIsWrong: "কোডটি সঠিক নয়",
  codeSend: "ফোন নম্বরে এসএমএস কোড পাঠানো হয়েছে",
  codeSendToEmail: "কোড ইমেল এ পাঠানো হয়েছে",
  codeSendToPhone: "ফোন নম্বরে কোড পাঠানো হয়েছে",
  codeSendToTelegram: "টেলিগ্রাম বটের মাধ্যমে কোড পাঠানো হয়েছে",
  codeVerificationDisabled: "কোড যাচাইকরণ নিষ্ক্রিয় করা হয়েছে",
  codeVerificationEnabled: "কোড যাচাইকরণ সক্রিয় করা হয়েছে",
  coinSelection: "মুদ্রা নির্বাচন",
  comboBoostBonus: {
    button: "খেলুন",
    content_title: "Combo Boost কীভাবে ব্যবহার করবেন:",
    good_luck: "Olymp.casino আপনার জন্য বড় জয়ের কামনা করে!",
    range_left_title: "ইভেন্টের সংখ্যা",
    range_right_title: "অডস",
    step_one: "ধাপ 1:",
    step_one_description: "এখনই আপনার উইনিং অ্যাকিউমুলেটর বেট সংগ্রহ করা শুরু করুন এবং দেখুন কীভাবে আপনি বর্ধিত অডস পেতে পারেন।",
    step_three: "ধাপ 3:",
    step_three_description: "বাছাই করার পর আপনার বেট রাখুন! বোনাস স্বয়ংক্রিয়ভাবে আপনার চূড়ান্ত অডস বৃদ্ধি করবে। আপনি 'আমার বেট'-এ আপনার বেট চেক করতে পারবেন। এটি একটি COMBOBOOST মার্কার দিয়ে হাইলাইট করা হবে।",
    step_two: "ধাপ 2:",
    step_two_description: "আপনার অ্যাকিউমুলেটর বেট সংগ্রহ করতে থাকুন এবং বোনাস বৃদ্ধি হতে দেখুন।",
    welcoming_range_title: "আপনার অডস খুঁজে বের করুন।",
    welcoming_text: "সকল নতুন গ্রাহকদের জন্য Olymp.casino-এর পক্ষ হতে চমৎকার সংবাদ আছে! এটি কাজ করে তা নিশ্চিত করার জন্য এই ফিচারটি নিজে ব্যবহার করে দেখুন! আমাদের বোনাস দিয়ে আপনার চূড়ান্ত অডস বাড়ানোর জন্য 1.5 বা তার বেশি ব্যবধানে 2 বা তার বেশি ইভেন্টের একটি অ্যাকিউমুলেটর বেট ধরুন। মনে রাখবেন, অ্যাকিউমুলেটর বেটে যত বেশি ইভেন্ট থাকবে আপনার বোনাস তত বেশি হবে।",
    welcoming_title: "EXPRESS-এ যত বেশি ইভেন্ট, ততবেশি বোনাস!"
  },
  commission: "কমিশন:",
  competitionAction: "নিম্নলিখিত গেমগুলির একটিতে খেলেই টুর্নামেন্টে অংশ নিন",
  competitionMembers: "টুর্নামেন্টে অংশগ্রহণকারীগণ",
  competitionParticipants: "অংশগ্রহণকারীদের তালিকা এখানে প্রদর্শিত হবে",
  competitionWinners: "বিজয়ীদের তালিকা এখানে প্রদর্শিত হবে",
  competitions: "সকল টুর্নামেন্ট",
  competitionsGames: "টুর্নামেন্ট",
  competitors: "{count}  টুর্নামেন্টে অংশগ্রহণকারীগণ",
  completeRegistration: "নিবন্ধন সম্পন্ন করুন",
  completeSecuritySettings: "আপনার ব্যক্তিগত ডেটা এবং তহবিলের জন্য নিরাপত্তা সেটিংস সম্পূর্ণ করুন৷",
  completeSignIn: "সাইন ইন সম্পন্ন করুন",
  completed: "টুর্নামেন্ট শেষ হয়েছে",
  conductError: "ত্রুটি",
  confirm: "নিশ্চিত করুন",
  confirmData: "ডেটা নিশ্চিত করুন",
  confirmInformation: "তথ্য নিশ্চিত করুন",
  confirmPersonalData: "আমি ব্যক্তিগত তথ্যের সত্যতা নিশ্চিত করছি এবং আমি বুঝি যে এই তথ্য পরিবর্তন করা যাবে না",
  confirmPhoneNumber: "ফোন নম্বর নিশ্চিত করুন",
  confirmPhoneThroughTelegram: "টেলিগ্রাম অ্যাপে যান এবং নিরাপদে অর্থ উত্তোলনের জন্য ফোন নম্বর নিশ্চিত করুন",
  confirmationCode: "কনফার্মেশন কোড",
  confirmationEmail: "ইমেইল কনফার্মেশন",
  confirmationPhone: "ফোন কনফার্মেশন",
  confirmed: "নিশ্চিত হয়েছে",
  congratulationsTrustWalletCreated: "অভিনন্দন! Trust Wallet তৈরি হয়েছে!",
  contact: "যোগাযোগ",
  continueSecuritySetup: "নিরাপত্তা সেটিংসে ফিরে যান",
  converting: "যাতে স্বয়ংক্রিয়ভাবে রূপান্তর হয়েছে",
  copeAddressMemo: "মেমো সফলভাবে কপি করা হয়েছে",
  copeAddressWallet: "ওয়ালেটের ঠিকানা সফলভাবে কপি করা হয়েছে",
  copeAddressWalletNew: "Your wallet address has been successfully copied",
  copeCode: "কোড সফলভাবে কপি করা হয়েছে",
  copeSumText: "টাকাটি সফল ভাবে কপি করা হয়েছে ",
  copy: "কপি ",
  copyAddress: "ঠিকানা কপি করুন",
  copyCode: "কোড কপি করুন",
  copyTheAddress: "ঠিকানা কপি করুন",
  countries: {
    bangladesh: "বাংলাদেশ",
    kazakhstan: "কাজাখস্তান",
    kyrgyzstan: "কিরগিস্তান",
    russia: "রাশিয়া",
    uzbekistan: "উজবেকিস্তান"
  },
  country: "দেশ নির্বাচন",
  countryNotFound: "দেশ খুঁজে পাওয়া যায়নি, বানান পরীক্ষা করুন",
  countrySelect: "দেশ নির্বাচন",
  coupon: "কুপন",
  couponContainsDependentOutcomes: "কুপন এ সংশ্লিষ্ট  ফলাফল রয়েছে",
  createWalletInTrustWallet: "Trust Wallet একটি ওয়ালেট তৈরি করুন",
  cryptoMemo: "মেমো",
  cryptoTournament: "ক্রিপ্টো টুর্নামেন্ট",
  cryptoWallerSuccessChanged: "ওয়ালেটের ঠিকানা সফলভাবে পরিবর্তন করা হয়েছে",
  cryptoWallet: "ক্রিপ্টো ওয়ালেট",
  cryptocurrency: "ক্রিপ্টোকারেন্সি",
  currency: "মুদ্রা",
  current: "বর্তমান",
  currentBalanceIsLessThanTheWithdrawalAmount: "সকল অর্থপ্রদানের পদ্ধতি এভেইলেবল নয়, বর্তমান ব্যালেন্স কোনো লেনদেনের জন্য প্রয়োজনীয় ন্যূনতম পরিমাণের চেয়ে কম",
  currentRates: "বর্তমান বেট",
  customerSupport: "কাস্টোমার সাপোর্ট",
  customizeDisplayedCoins: "প্রদর্শিত কয়েন নিজের মতো করতে, উপরের ডান কোনায় স্লাইডারগুলোতে ক্লিক করুন। টোকেন যোগ করুন পেজে গিয়ে সার্চ বারে Doge টাইপ করুন। এরপর Doge কয়েন সক্রিয় করতে তার পাশের স্লাইডারে ক্লিক করুন।",
  cyrillicInPasswordNotAvailable: "পাসওয়ার্ডে সিরিলিক অক্ষর অনুমোদিত নয়",
  data: "তারিখ",
  dataNotSpecified: "ডেটা নির্দিষ্ট নয়",
  date: "তারিখ",
  dateFrom: "তারিখ থেকে",
  dateOfTransaction: "লেনদেন তারিখ",
  dateTo: "তারিখ পর্যন্ত",
  deadline: "ডিসেম্বরে",
  december: "শেষ হবে",
  decline: "প্রত্যাখ্যান",
  demo: "ডেমো",
  deposit: "অর্থ জমা করুন",
  depositAccount: "অ্যাকাউন্টে অর্থ জমা করুন",
  depositBK: "বুকমেকার থেকে অর্থ জমা করুন",
  depositBonus: "অর্থ জমার জন্য {bonus} বোনাস",
  depositForBonus: "বোনাস পাওয়ার জন্য {sum} থেকে শুরু করে যেকোনো পরিমাণ অর্থ জমা করুন",
  depositNoun: "অর্থ জমা করুন",
  depositRequired: "আপনাকে <span class='bonus-item__sum'> {sum} </span> পরিমাণ একটি ডিপোজিট করতে হবে৷",
  description: "বর্ণনা",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "স্লট অনলাইন ➔ খেলুন ✓অর্থের জন্য, ✓চার্জ ফ্রি ভাবে এবং ✓নিবন্ধন ছাড়া। {company} ক্যাসিনো ✓ফ্রি ✓জনপ্রিয় ✓আধুনিক স্লট মেশিন প্রদান করে ✓অফিশিয়াল প্রোভাইডারদের পক্ষ থেকে, আর সাথে আছে ✓উদারহস্ত বোনাস এবং ✓বিভিন্ন বিষয়।"
    }
  },
  details: "আরো বিস্তারিত তথ্য",
  docsWasApproved: "ডকুমেন্ট সফলভাবে চেক করা হয়েছে",
  docsWasDeclined: "ডকুমেন্ট যাচাই করা হয়নি",
  documentAttacheMessage: "আমরা 24 ঘণ্টার মধ্যে এটি চেক করবো। এর পর অর্থ উত্তোলন পদ্ধতি এভেইলেবল হবে।",
  documentAttacheSuccess: "আপনার ডকুমেন্ট সফলভাবে পাঠানো হয়েছে।",
  documentDeleteSuccess: "নথি সফলভাবে মুছে ফেলা হয়েছে",
  documentNumber: "ডকুমেন্টের নম্বর",
  documentUpload: "ডকুমেন্ট ডাউনলোড হচ্ছে",
  done: "প্রস্তুত!",
  doneThresholdConditions: "জমাকৃত অর্থ দিয়ে বাজি ধরার শর্ত পূরণ হয়েছে",
  download: "ডাউনলোড",
  downloadApp: "অ্যাপটি ডাউনলোড করুন",
  downloadOlimpApp: "Olymp অ্যাপ ডাউনলোড করুন",
  download_app: "Olymp অ্যাপ ডাউনলোড করুন",
  dropswins: {
    eight: "9000€ পুরস্কারের ড্র র‍্যান্ডম ভাবে হয়। জেতার জন্য খেলুন!",
    eighteen: "নিয়মাবলী",
    eleven: "সাপ্তাহিক টুর্নামেন্টের পুরস্কারের টেবিল (নিয়মিত সপ্তাহ)",
    fifteen: "দৈনিক পুরস্কারের টেবিল",
    five: "প্রতিদিন",
    four: "টুর্নামেন্ট",
    fourteen: "সাপ্তাহিক টুর্নামেন্টের পুরস্কারের টেবিল (নিয়মিত সপ্তাহ)",
    nine: "4 х 62 000€ সাপ্তাহিক টুর্নামেন্ট",
    nineteen: "1. এটি একটি নেটওয়ার্ক প্র্যাগমাটিক প্লেTM ক্যাম্পেইন। ক্যাম্পেইনটি 11.02.2021 থেকে 17.11.2021 CET (01:01 11.02.2021 থেকে 00:59 18.11.2021 EET) পর্যন্ত চলে <br> 2। ক্যাম্পেইনটি 10টি পর্যায়ে পরিচালিত হয়, যেখানে প্রতিটি পর্যায় 4 সপ্তাহ স্থায়ী হয়।<br> 3. পুরো প্রোমোশনের মোট পুরস্কারের অর্থের পরিমাণ হলো €4,000,000, যা 40 x 62,000 €-এর সাপ্তাহিক টুর্নামেন্ট এবং 40 x 63,000 €-এর সাপ্তাহিক পুরস্কারের ড্র নিয়ে গঠিত।<br> 4. নিচে এই প্রোমোশনের 7 নম্বর পর্যায়ের শর্তাবলী আছে। অনুগ্রহ করে মনে রাখবেন যে টুর্নামেন্টের পদ্ধতি পর্যায়ের উপর নির্ভর করে পরিবর্তিত হয়।<br> 5. যেকোনো নেটওয়ার্ক কোম্পানি টুর্নামেন্ট বা ড্র-এ অংশ নিতে হলে প্লেয়ারদের অন্তর্ভুক্ত যেকোনো গেম ওপেন করে অংশগ্রহণ নিশ্চিত করতে হবে/সেগুলো নিয়মের সাথে সম্মত হতে হবে।<br> 6. চার (4) সপ্তাহের টুর্নামেন্ট এবং পুরস্কার ড্র নিম্নরূপে পরিচালনা করা হবে:<br> সপ্তাহ 27:  11.08.2021, 20:01 -  18.08.2021, 19:59 EET<br> সপ্তাহ  28:  18.08.2021, 20:01 -  25.08.2021, 19:59 EET<br> 7। কোয়ালিফায়িং গেমস:<br> Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™\"",
    one: "Pragmatic Play-এর থেকে Drops & Wins Online Tournament-এ যোগ দিন যেখানে বিজয়ী হতে পারে সবাই!",
    seven: "সর্বোচ্চ একক স্পিন জয়ের মাধ্যমে লিডারবোর্ডের শীর্ষে পৌঁছান।",
    seventeen: "এই টুর্নামেন্টটি জয়ের গুণক হিসাব করা হয় একটি প্রক্রিয়া ব্যবহার করে যাতে বেটের আকার নির্বিশেষে টুর্নামেন্টে অংশগ্রহণ সকল প্লেয়ারের জন্য ন্যায্য হয়। উদাহরণস্বরূপ, আপনি €2 বেট করে €10 জিতলে আপনার বিজয়ী গুণক হলো পাঁচ। এই ক্ষেত্রে, আপনি পাঁচ পয়েন্ট পাবেন। সর্বোচ্চ একক স্পিন জয়ের মাধ্যমে শীর্ষ 1200 লিডারবোর্ডে যান।",
    six: "অফারে গেম ওপেন করুন, টুর্নামেন্টে যোগ দিন এবং খেলতে শুরু করুন (সর্বনিম্ন বেট হলো 0.50 ইউরো)*",
    sixteen: "স্বয়ংক্রিয়ভাবে টুর্নামেন্টে ও পুরস্কার ড্র-এ অংশ নিতে আপনার শুধুমাত্র একবার ক্যাম্পেইনে যোগ দিতে হবে।",
    ten: "4 х 63 000€-এর সাপ্তাহিক পুরস্কারের ড্র",
    thirteen: "পুরস্কার",
    three: "খেলুন",
    twelve: "অবস্থান",
    twenty: "সাপ্তাহিক টুর্নামেন্টসমূহ",
    twentyfour: "ইনস্ট্যান্ট ক্যাশব্যাক",
    twentyone: "1. লিডারবোর্ড পয়েন্টের উপর ভিত্তি করে, এবং বেট বিবেচনায় নিয়ে টুর্নামেন্টে অংশগ্রহণকারী যেকোনো গেমে অর্জন করা স্পিন প্রতি সর্বোচ্চ জয়ের ভিত্তিতে পয়েন্ট প্রদান করা হয়।<br> 2. লিডারবোর্ডটি রিয়েল টাইমে আপডেট করা হয় এবং টুর্নামেন্টে অন্তর্ভুক্ত যেকোনো গেম খেলার সময় প্লেয়াররা যেকোনো সময় লিডারবোর্ডটি দেখতে পারেন।<br> 3. দুই (2) বা ততোধিক প্লেয়ার লিডারবোর্ডে একই অবস্থানে থেকে টুর্নামেন্ট শেষ করলে, এই পয়েন্ট প্রথমে যে প্লেয়ার অর্জন করেছেন তাকে উচ্চতর স্থান দেওয়া হবে।<br> 4. নির্দিষ্ট পরিমাণ হিসেবে প্লেয়ারদের পুরস্কার প্রদান করা হয়।<br> 6. সাপ্তাহিক পুরস্কারে 1200 নগদ অর্থ পুরস্কারসহ মোট পুরস্কার € 62,000.<br> 7. অবস্থান - সাপ্তাহিক পুরস্কার<br> 1. €10,000<br> 2. €5,000<br> 3. €2,000<br> 4-10. €1,000<br> 11-20. €500<br> 21-50. €200<br> 51-100. €100<br> 101-300. €50<br> 301-600. €20<br> 601-1200. €10",
    twentythree: "1. প্রোমোশনের প্রতিটি সপ্তাহে সাতটি (7) দৈনিক পুরস্কারের ড্র অনুষ্ঠিত হয়। <br> 2. প্রতিটি প্রোমোশনের সময়, শর্ত পূরণ করে এমন একটি (1) স্পিন পুরস্কারের অর্থ থেকে একটি (1) পুরস্কার অর্জন করতে পারে। <br> 3. পুরস্কার র‍্যান্ডমভাবে ড্র করা হয়। টুর্নামেন্টের অন্তর্ভুক্ত গেমগুলোতে অংশগ্রহণের নিয়ম ও পুরস্কার টেবিল পাওয়া যায়। পুরস্কারের টেবিলটি রিয়েল টাইমে আপডেট করা হয় যা বর্তমান অবস্থানের পাশাপাশি বাকি পুরস্কারের সংখ্যাও প্রদর্শন করে। <br> 4. টুর্নামেন্টের অন্তর্ভুক্ত গেমগুলোতে অংশগ্রহণকারী প্রত্যেকের জন্য পুরস্কার ট্যাবে নির্দেশিত হিসাব অনুযায়ী পুরস্কার প্রদান করা হবে। <br> 5. নির্দিষ্ট পরিমাণ হিসেবে প্লেয়ারদের পুরস্কার প্রদান করা হয়। <br> 6. পুরস্কারের ড্র-এ অংশ নিতে, টুর্নামেন্টে অন্তর্ভুক্ত গেমে (গুলোতে) প্রকৃত অর্থে ন্যূনতম € 0.50-এর একটি বেট রাখতে হবে। একজন প্লেয়ার প্রতিদিন একাধিক পুরস্কার জিততে পারেন। <br> 7. পুরস্কারের ড্র প্রতিদিন শেষ হবে (i) 00:59 EEST/EET-তে বা (ii) সকল পুরস্কার প্রদানের পর (যেটি প্রথমে আসে)। <br> 8. যদি কোনো নির্দিষ্ট দৈনিক ড্র-এর প্রাইজ পুল সম্পূর্ণরূপে বিতরণ করা না হয়, তাহলে পরবর্তী পর্যায়ের জন্য PragmaticPlay ™-এর বিবেচনার ভিত্তিতে যেকোনো উদবৃত্ত অর্থ পুরস্কারের তহবিলে ট্রান্সফার করা হবে। <br> 9. সাপ্তাহিক পুরস্কারের অর্থ মোট €63,000 এবং দৈনিক পুরস্কারের অর্থে 500টি নগদ পুরস্কার এবং মোট €9,000-এর ফ্রি স্পিন রয়েছে। <br> 10. পরিমাণ - দৈনিক পুরস্কার <br> 1 X € 1,000 <br> 2 X € 500 <br> 5 X € 100 <br> 12 X € 50 € 110 X € 20 € 370 X € 10 <br> 11। বিজয়ীরা তাদের পুরস্কার নগদ অর্থে পাবেন। নগদ পুরস্কার স্বয়ংক্রিয়ভাবে টুর্নামেন্ট শেষ হওয়ার পরে {baseLink}-এ ক্যাসিনোতে তাদের গেমিং অ্যাকাউন্টে জমা হয়ে যাবে। <br> 12. {baseLink} যেকোনো সময়ে প্রোমোশনের শর্তাবলী পরিবর্তন বা বাতিল করার অধিকার সংরক্ষণ করে। <br> 13. {baseLink}-এর সাধারণ শর্তাবলী প্রযোজ্য হয়।",
    twentytwo: "সাপ্তাহিক পুরস্কারের ড্র",
    two: "€500,000-এর পুরস্কারের অর্থ পর্যায় ভিত্তিতে বিতরণ করা হয় - প্রতি সপ্তাহে €125,000! অংশ নেওয়ার জন্য কেবলমাত্র নিচের ধাপগুলো অনুসরণ করুন!"
  },
  email: "ইমেইল",
  emailNeedValid: "যাচাইকরণ কোড আপনার ই-মেইলে পাঠানো হবে",
  emailSuccessfullyApproved: "ইমেইল সফলভাবে নিশ্চিত করা হয়েছে",
  emptyGames: "আমরা আপনার জন্য এই ধরনের গেম খুঁজে পাইনি",
  emptyPromoPage: "চলমান প্রোমোশন এখানে প্রদর্শিত হবে",
  ended: "সম্পন্ন হয়েছে",
  engineeringWorks: "5 মিনিট পরে, সাইটে কারিগরি কাজ করা হবে",
  english: "ইংরেজি",
  enter: "যোগ দিন",
  enterCode: "কোড লিখুন",
  enterCodeFromEmail: "ই-মেইলে পাওয়া কোডটি লিখুন",
  enterCorrectPhoneNumber: "সঠিক টেলিফোন নম্বর লিখুন",
  enterCryptoWallet: "ক্রিপ্টো ওয়ালেট প্রবেশ করান",
  enterCryptoWalletOnProfilePage: "আপনার জয়ের অর্থ পাওয়ার জন্য আপনার ব্যক্তিগত অ্যাকাউন্টে Doge ক্রিপ্টো ওয়ালেট প্রবেশ করান",
  enterGameName: "গেমের নাম লিখুন",
  enterGameNameOrProvider: "গেম বা প্রদানকারীর নাম লিখুন",
  enterMoreCharacters: "আরো প্রতীক লিখুন",
  enterPromoCode: "প্রোমো কোড লিখুন",
  enterSMS: "SMS -এ প্রাপ্ত কোড লিখুন",
  enterSixDigitCode: "অ্যাপ থেকে 6-সংখ্যার কোড টি লিখুন",
  enterValidEmail: "সঠিক ইমেইল লিখুন",
  enterWalletAddress: "আপনার টুর্নামেন্টের জয়ের অর্থ পেতে এখন বা পরে আপনার Doge ক্রিপ্টো ওয়ালেটের ঠিকানা লিখুন।",
  enterYourBankCardDetails: "আপনার ব্যাংক কার্ডের বিবরণ লিখুন, পেমেন্ট সিস্টেমের শর্তাবলীতে সম্মতি দিন এবং \"পে\" ক্লিক করুন",
  entrance: "লগ ইন",
  err404subtitle: "আমরা মূল পেজে আপনার জন্য অপেক্ষা করছি!",
  err404title: "দুর্ভাগ্যবশত, কিছুই পাওয়া যায়নি ...",
  error: "ত্রুটি",
  errorPasswordField: "পাসওয়ার্ডে অবশ্যই সংখ্যা, বড় হাতের ও ছোট হাতের অক্ষর থাকতে হবে",
  errorPaymentDataInitialization: "পেমেন্ট শুরু করার সময় ত্রুটি",
  errorPaymentUrlInitialization: "পেমেন্ট প্রসেস করার সময় ত্রুটি",
  errorWhileSendingCode: "কোডসহ ম্যাসেজ পাঠানো ব্যর্থ হয়েছে, অনুগ্রহ করে আবার অনুরোধ করার চেষ্টা করুন।",
  errorsWhileValidate: "ফর্ম বৈধতায় ত্রুটি",
  euro_slot: {
    description: "Euro Slots 2024 অনলাইন খেলা শুধুমাত্র {platform} - সেরা অফিসিয়াল গেমিং স্লট। অনলাইন ক্যাসিনোতে বিনামূল্যে এবং অর্থের জন্য খেলুন।",
    end: "টুর্নামেন্ট টি শেষ",
    "final": "ফাইনালে পৌঁছান",
    inProgress: "ম্যাচটি লাইভ",
    mathPrize: "ম্যাচ পুরস্কার তহবিল:",
    onWallet: "অ্যাকাউন্টে",
    prize: "মোট পুরস্কার তহবিল:",
    "prize-short": "পুরস্কার",
    prizeFond: {
      "1\/2": "<p>সেমি-ফাইনাল:</p> পুরস্কারের তহবিল",
      "1\/4": "<p>কোয়ার্টার ফাইনালের পুরস্কারের তহবিল:</p>",
      "1\/8": "<p>১/৮ ফাইনালের পুরস্কার তহবিল:</p>",
      "final": "<p>ফাইনালের পুরস্কার তহবিল:</p>"
    },
    rules: {
      "1": "প্রচারটি ১৩।০৬।২০২৪ ০০-০০ জিএমটি +৫  থেকে ১৪।০৭।২০২৪ ০০-০০ জিএমটি +৫ পর্যন্ত চলবে",
      "2": "পুড়ো টুর্নামেন্ট এর মোট পুরস্কার তহবিল: {sum}",
      "3": "সময়সূচী অনুযায়ী, টুর্নামেন্ট গ্রিড বরাবর সরানো স্লটের মধ্যে একটি যুদ্ধ অনুষ্ঠিত হয়",
      "4": "যে ব্যবহারকারীরা একটি নির্দিষ্ট প্রচারমূলক গেমের বিজয়ে সর্বাধিক অবদান রেখেছেন তারা নিজেদের মধ্যে পুরস্কার তহবিল বিতরণ করে নিবেন",
      "5": "পর্যায় 1/8 দম্পতির জন্য তারিখ ({sum}):",
      "6": "পর্যায় 1/4 দম্পতির জন্য তারিখ ({sum}):",
      "7": "পর্যায় 1/2 দম্পতির জন্য তারিখ ({sum}):",
      "8": "চূড়ান্ত তারিখ ({sum}):",
      "9": "পুরষ্কার 24 ঘন্টার মধ্যে গেমিং অ্যাকাউন্টে স্বয়ংক্রিয়ভাবে জমা হয়"
    },
    stage1: "<span>নিবন্ধন করুন</span> এবং \"অংশগ্রহণ করুন\" বোতামে ক্লিক করুন৷",
    stage2: "<span>অংশগ্রহণকারী গেমগুলির যেকোনো একটিতে বাজি ধরুন</span> এবং পয়েন্ট স্কোর করুন৷",
    stage3: "<span>শীর্ষ জন খেলোয়াড়</span> মোট পুরস্কারের তহবিল ভাগ করবে",
    stages: {
      "1\/2": "সেমিফাইনাল",
      "1\/4": "কোয়ার্টার ফাইনাল",
      "1\/8": "1/8 ফাইনাল",
      "final": "ফাইনাল"
    },
    stagesAtStart: {
      "1\/2": "ফাইনাল শুরু হয়:",
      "1\/4": "1/2 ফাইনাল শুরু হওয়ার আগে:",
      "1\/8": "1/4 ফাইনাল শুরু হওয়ার আগে:",
      "final": "ফাইনাল",
      pre: "1/8 ফাইনাল শুরু হয়:"
    },
    start: "কিভাবে অংশগ্রহণ করতে হয়",
    table: "টুর্নামেন্ট টেবিল",
    title: "Euro Slots 2024 টুর্নামেন্ট - {platformSite} ক্যাসিনোতে অনলাইনে স্লট খেলুন\n",
    winners: "টুর্নামেন্ট বিজয়ীরা"
  },
  events: "ইভেন্টস",
  exchangeRateInTenge: "ট্যাঞ্জে বিনিময় হার",
  exit: "প্রস্থান করুন",
  express: "অ্যাকিউমুলেটর",
  expressCoef: "অ্যাকিউমুলেটরের অডস",
  expressSystem: "অ্যাকিউমুলেটরের সিস্টেম",
  failed: "পদক্ষেপ নেওয়া হয়নি",
  fastBet: "কুইক বেট",
  fastbetDetailedDescription: "দ্রুত বাজি /কুইক বেট আপনাকে মাত্র দুটি ক্লিকে একক বাজি/সিঙ্গেল বেট ধরার অনুমতি দেয়। শেষ বাজির পরিমাণ মনে রাখা বাজির প্রক্রিয়াটিকে আরও বেশি",
  fastbetSetting: "দ্রুত বাজি /কুইক বেট সেটিংস",
  fastbetSum: "দ্রুত বাজির পরিমাণ",
  favorite: {
    added: "গেম ফেভারিটে যোগ করা হয়েছে",
    removed: "গেমটি ফেভারিট থেকে সরানো হয়েছে"
  },
  favorites: "ফেভারিট",
  february: "ফেব্রুয়ারি",
  fieldRequire: "প্রয়োজনীয় ঘর",
  fileAttached: "ফাইল সংযুক্ত করা হয়েছে",
  fileNotAttached: "ফাইল সংযুক্ত করা হয়নি",
  fillInformation: "তথ্য পূরণ করুন",
  fillProfileInfoForWithdraw: "অর্থ উত্তোলন করতে অনুগ্রহ করে আপনার ব্যক্তিগত তথ্য পূরণ করুন।",
  fillRequiredInfoBelow: "অনুগ্রহ করে নিচের প্রয়োজনীয় তথ্য পূরণ করুন",
  filter: "ছাঁকনি",
  filterByDate: "তারিখ ফিল্টার করুন",
  filtersText: {
    inTheNextSixHours: "পরবর্তী 6 ঘণ্টার মধ্যে",
    inTheNextTwentyFourHours: "পরবর্তী 24 ঘণ্টার মধ্যে",
    inTheNextTwoHours: "পরবর্তী 2 ঘণ্টার মধ্যে",
    nextThreeDays: "পরবর্তী 3 দিনের মধ্যে",
    nextTwelveHours: "পরবর্তী 12 ঘণ্টার মধ্যে",
    nextWeek: "পরবর্তী সপ্তাহের মধ্যে",
    today: "আজ",
    tomorrow: "কাল",
    whenever: "যেকোনো সময়"
  },
  findOutAddressOfDogeWallet: "Doge ওয়ালেটের ঠিকানা জেনে নিন",
  fine: "ঠিক আছে\n",
  firstAuthMessage: "ফোন নম্বরে ইউজারনেইম ও পাসওয়ার্ডসহ একটি SMS পাঠানো হয়েছিল। আপনার অ্যাকাউন্টে অর্থ জমা করুন এবং আপনার প্রথম জয় অর্জন করুন",
  firstDeposit: "প্রথম জমাতে!",
  forCorrectGamePushRefresh: "গেমটি সঠিকভাবে প্রদর্শন করতে রিফ্রেশ বাটনে ক্লিক করুন",
  forEndCompetition: "টুর্নামেন্ট শেষ না হওয়া পর্যন্ত",
  forMoreInformation: "আরও তথ্যের জন্য",
  forStartCompetition: "টুর্নামেন্ট শুরু হওয়ার আগে",
  forgotPassword: "পাসওয়ার্ড ভুলে গেছেন?",
  fraud: "AML নীতিমালা",
  freeBetsButton: "পড়ুন",
  freeBetsCount: "বিনামূল্যে বাজি উপলব্ধ:",
  freeBetsStepFour: "আপনার বাজি রাখুন",
  freeBetsStepOne: "\"স্পোর্টস\" বিভাগটি খুলুন",
  freeBetsStepThree: "একটি ইভেন্ট নির্বাচন করুন",
  freeBetsStepTwo: "কুপনে «Freebet» সক্রিয় করুন",
  freeBetsTitle: "খেলাধুলার উপর বিনামূল্যে বাজি",
  freeSpinsInGame: "একটি গেমে ফ্রি স্পিন",
  freespin: "ফ্রি স্পিন",
  freespinsAvailable: "ফ্রি স্পিন আছে",
  from: "{date} থেকে",
  fromAnySum: "যেকোনো পরিমাণ থেকে",
  fromNumber: "থেকে",
  fromSmth: "{value} থেকে",
  fulfillConditionsForWithdrawal: "অর্থ উত্তোলনের জন্য সকল শর্ত পূরণ করুন।",
  fund: "পুরস্কারের অর্থ",
  future: "ভবিষ্যৎ",
  game: "গেম",
  gameDescTemplate: "{gameName} স্লট মেশিনটি সুপরিচিত ডেভেলপার {providerName}-এর তৈরি একটি অনলাইন স্লট। বিনামূল্যে {gameName} স্লট মেশিন খেলুন বা প্রকৃত অর্থের জন্য খেলতে নিবন্ধন করুন।",
  gameForMoneyOnlyForAuthUser: "শুধুমাত্র অনুমোদিত ব্যবহারকারীগণ অর্থের জন্য খেলতে পারেন",
  gameInOtherTab: "গেমটি অন্য ট্যাবে খোলা আছে",
  gameNotAvailableBonus: "বোনাসের শর্তের কারণে গেমটি এভেইলেবল নয়",
  gameNotAvailableGeoRestriction: "গেমটি আপনার অঞ্চলে এভেইলেবেল নয়৷",
  gameNotFound: "গেম পাওয়া যায়নি",
  gameTitleTemplate: "{gameName} স্লট মেশিন. {company} অনলাইন ক্যাসিনোতে বিনামূল্যে খেলুন",
  gameUnavailable: "গেমটি সাময়িকভাবে এভেইলেবল নয়",
  game_categories: "গেমের প্রকারভেদ",
  games: {
    tryOther: "অন্যান্য গেমগুলো চেষ্টা করুন"
  },
  gamesNotFound: "গেম পাওয়া যায়নি",
  geoRestrictionDesc: "দুর্ভাগ্যবশত, এই গেমটি আপনার অঞ্চলে এভেইলেবেল নয়৷",
  geoRestrictionDescLine2: "আমরা আপনাকে ক্যাটালগ থেকে অন্য গেম বেছে নেওয়ার পরামর্শ দিচ্ছি",
  get: "পান",
  getBonus: "বোনাস পান",
  getBonusByPromoCode: "প্রোমো কোডের মাধ্যমে বোনাস পান",
  getGainFromFreeSpins: "ফ্রি স্পিন থেকে জয় পাওয়া",
  getNewCode: "নতুন কোড নিন",
  getSMS: "SMS-এ কোড পান",
  go: "যান",
  goBack: "ফিরে যান",
  goToGame: "খেলায় যান",
  goToGames: "খেলায় প্রবেশ করুন",
  goToHome: "প্রধান পেজে ফিরে যান",
  goToOlimpCasinoAndPlayFavoriteGames: "Go to Olimp Casino and play your favorite games:)",
  goToVolet: "volet.com (advcash) ওয়েবসাইটে যান",
  goToWallet: "ওয়ালেটে যান",
  goesNow: "এখন খেলছেন",
  gold: "গোল্ড",
  guarantee: {
    five: "গেম থেকে স্বেচ্ছায় ত্যাগ। যদি, খেলার ইচ্ছা কমাতে, আপনি আপনার অ্যাকাউন্ট ব্লক করার অনুরোধ নিয়ে আমাদের ক্যাসিনো সাপোর্ট সার্ভিসের সাথে যোগাযোগ করেন, আপনার অনুরোধ পূরণ করা হবে। আপনি অপরিবর্তনীয়ভাবে আপনার প্রোফাইল মুছে ফেলতেও পারেন। অন্য ক্ষেত্রে, প্লেয়ারের অনুরোধে, কিছু সময় পরে এটি পুনরুদ্ধার করা যেতে পারে।",
    four: "যে প্লেয়াররা গেমটিতে ব্যক্তিগত অ্যাক্সেস সীমাবদ্ধ করতে চান তাদের জন্য, নিম্নলিখিত অপশনগুলো তৈরি করা হয়েছে:",
    one: "দায়িত্বশীল গেমিং",
    seven: "সীমিত প্রবেশাধিকার। আপনি যদি বিভিন্ন ওয়েব সাইট থেকে নিজেকে রক্ষা করতে চান যেগুলো গ্যাম্বলিং খেলার বিজ্ঞাপন কিংবা সুযোগ দেয়, তাহলে আপনার বিশেষ সফটওয়্যার ব্যবহার করা উচিত। এটি সিস্টেমগুলোকে ফিল্টার করে এবং গ্যাম্বলিং-এ আসক্তিপ্রবণ ব্যবহারকারীদের জন্য একটি নিরাপদ অনলাইন অভিজ্ঞতা নিশ্চিত করে। উপরন্তু, অবাঞ্ছিত রিসোর্সে অ্যাক্সেস থেকে শিশুদের প্রতিরোধ করতে এই সফটওয়্যার ব্যবহার করা যেতে পারে। এই ধরনের সফটওয়্যারের উদাহরণ: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).(www.cyberpatrol.com)।",
    six: "বিশেষায়িত সাহায্য। গ্যাম্বলিং-এর আসক্তি তৈরি হলে, প্লেয়াররা উপযুক্ত বিশেষজ্ঞদের সাহায্য নিতে পারেন। আপনি যাদের সাহায্য পেতে পারেন: Gamblers Anonymous (www.gamblersanonymous.org.uk) - বেনামী জুয়াড়িদের একটি আন্তর্জাতিক কমিউনিটি, যারা আসক্ত জুয়াড়িদের সহায়তা প্রদান করেন; GamCare (www.gamcare.org.uk) - একটি ইংরেজি-ভাষী সংস্থা যা প্লেয়ারদের আসক্তি থেকে মুক্তি পেতে সহায়তা করে; Gambling Therapy (www.gamblingtherapy.org) একটি ইউকে-ভিত্তিক সংস্থা যা সাধারণ অসুস্থতার বিরুদ্ধে লড়াইয়ে উপযুক্ত সহায়তা প্রদান করে।",
    three: "আপনি যদি গ্যাম্বলিং-এর প্রতি একটু আসক্ত বোধ করেন, তাহলে সবার আগে বের করুন যে গ্যাম্বলিং আপনার জন্য কী। গ্যাম্বলিং যদি জীবনের অসুবিধা থেকে পালানোর চেষ্টা হয়, যদি এটি আপনার প্রায় সম্পূর্ণ অবসর শেষ করে দেয় এবং কাজে হস্তক্ষেপ করে, তাহলে এটি ইতোমধ্যেই প্রথম ইঙ্গিত। আপনি যদি খেলার জন্য অর্থ ধার করেন এবং খেলা ছাড়া আপনার দিনটি আর কল্পনা করতে পারেন না, তাহলে এটি একটি নিশ্চিত লক্ষণ যে আপনার উল্লেখযোগ্য পরিবর্তন নিয়ে আসা প্রয়োজন।",
    two: "ওয়েব সাইটে খেলা ব্যবহারকারীদের প্রতি {titlePure}-এর কিছু দায়িত্ব রয়েছে। ক্যাসিনো প্রশাসন প্লেয়ারদের গ্যাম্বলিং আসক্তির সম্ভাব্য পরিণতি এড়াতে সাহায্য করতে প্রস্তুত। গেমের বিষয় হলো ইতিবাচক আবেগ প্রদান করা এবং আনন্দ নিয়ে আসা। অবশ্যই, ব্যর্থতা আসতে পারে, তবে এর ফলে কোনো ক্ষেত্রেই কোনো আর্থিক বা সামাজিক অসুবিধা সৃষ্টি হওয়া উচিত নয়।"
  },
  hasMinimalDeposit: "ন্যূনতম পরিমাণ অর্থ জমা করা হয়েছে",
  haveActivatedFastbetMode: "আপনি দ্রুতবাজি/কুইক বেট প্রক্রিয়া  সক্রিয় করেছেন৷ নিয়ম দেখতে, ক্লিক",
  haveNotEmailContactUs: "আপনি যদি ইমেইল না পেয়ে থাকেন, তাহলে অনুগ্রহ করে আপনার \"স্প্যাম\" এবং \"প্রোমোশন ” ফোল্ডার চেক করুন বা {0}-এর সাথে যোগাযোগ করুন",
  haveNotPhoneContactUs: "আপনি যদি আপনার ফোন নম্বরে কোনো SMS না পেয়ে থাকেন, অনুগ্রহ করে {0}-এর সাথে যোগাযোগ করুন",
  here: "এখানে",
  hiddenConditions: "লুকায়িত শর্তাবলী",
  hide: "লুকান",
  hideBonusCondition: "বোনাস শর্তাবলী লুকান",
  hideDetails: " বিস্তারিত আড়াল করুন",
  history: "ইতিহাস",
  historyBets: "বেটের ইতিহাস",
  historyPayments: "লেনদেনের ইতিহাস",
  historyTransactions: "লেনদেনের ইতিহাস",
  hotGame: "জনপ্রিয়",
  hotGames: "হট গেম",
  hotToBuyCryptoCurrency: "কিভাবে ক্রিপ্টোকারেন্সি কিনবেন?",
  howCanBuyCryptocurrency: "আমি কীভাবে ক্রিপ্টোকারেন্সি ক্রয় করতে পারি?",
  howCreateCryptoWallet: "কীভাবে একটি ক্রিপ্টো ওয়ালেট তৈরি করতে হয়?",
  howCreateWallet: "কীভাবে একটি ওয়ালেট তৈরি করা যায়?",
  howToCreateCryptoWallet: "কীভাবে একটি ক্রিপ্টো ওয়ালেট তৈরি করতে হয়?",
  howToFindOutWalletNumber: "আমার ওয়ালেট নম্বর কীভাবে জানবো?",
  howToInstallApp: "অ্যাপ ইনস্টল করবেন কিভাবে?",
  howToViewMyCryptoWalletInOlimp: "আমি কিভাবে আমার ক্রিপ্টো ওয়ালেট দেখতে পারি?",
  howTopUp: "কীভাবে অর্থ জমা করতে হবে",
  howTransferCrypt: "কীভাবে ক্রিপ্টোকারেন্সি ট্রান্সফার করতে হয়",
  howTransferCryptStep1: "ওয়ালেট বা এক্সচেঞ্জে লগ ইন করুন",
  howTransferCryptStep2: "নির্বাচিত {currency} কয়েনটি খুঁজে নিন",
  howTransferCryptStep3: "আমাদের ওয়ালেটের ঠিকানা পেস্ট করুন",
  howTransferCryptStep4: "নির্দিষ্ট করে সেই পরিমাণ অর্থ পাঠান",
  iPaid: "আমি জমা করেছি ",
  idWasCopied: "You copied transaction id",
  inSettings: "সেটিংসে",
  information: "তথ্য",
  informationConfirmWithdraw: "নিরাপত্তা ও উত্তোলনের জন্য আপনার সকল তথ্য নিশ্চিত করুন। আপনার ইমেইল ঠিকানা বা ফোন নম্বর পরিবর্তন করতে, যোগাযোগ করুন",
  informationConfirmWithdrawSupport: "সাপোর্ট সার্ভিস",
  informationForUpdateProfileData: "আপনার যোগাযোগের তথ্য আপডেট করতে, অনুগ্রহ করে সহায়তার সাথে যোগাযোগ করুন",
  installApp: "অ্যাপটি ইনস্টল করার জন্য {0}",
  installTrustWalletApp: "Trust Wallet অ্যাপ ইনস্টল করুন",
  instant: "ইনস্ট্যান্ট",
  instantCash: "ক্যাশব্যাক",
  instantCashback: "ইনস্ট্যান্ট ক্যাশব্যাক",
  instantWithdrawal: "ইনস্ট্যান্ট অর্থ উত্তোলন",
  instantly: "তাৎক্ষনিকভাবে",
  insufficientFundsAvailable: "অপর্যাপ্ত অর্থ। এভেইলেবল:",
  invalidCryptoWallet: "ওয়ালেটের ঠিকানা বৈধ নয়",
  invalidDateFormat: "অবৈধ তারিখ বিন্যাস",
  invalidDateInterval: "নির্বাচিত মধ্যবর্তী সময়টি ভুল",
  invalidStartDate: "শুরুর তারিখটি ভুল",
  iosWebAppInstruction: "iOS নির্দেশাবলী",
  jackpot: "জ্যাকপট",
  jackpotGame: "জ্যাকপটসহ",
  january: "জানুয়ারি",
  july: "জুলাই",
  june: "জুন",
  kazakh: "কাজাখ",
  kycPolicy: "KYC নীতিমালা",
  latestGames: "সাম্প্রতিক গেম",
  leftCount: "{count} বাকি আছে",
  leftDeposit: "{sum} পরিমাণ অর্থ জমা করা বাকি",
  licenseCuracao: "একজন লাইসেন্সধারী হিসেবে Perantia N.V. (<a href='https://{domain}' target='_blank'>{domain}</a>) এই ওয়েবসাইটের কনটেন্টের মালিক এবং তারাই এগুলোর পরিচালনা করেন (Curacao license No. #365/JAZ)। সমস্ত অধিকার সংরক্ষিত এবং আইন দ্বারা সুরক্ষিত।",
  lineOn: "বাজির লাইন এর জন্য {date}",
  linkIsReady: "লিঙ্কটি প্রস্তুত",
  liveCashBackDesc: "{company}, শুধুমাত্র ভিআইপি ক্লায়েন্টদের জন্য এভেইলেবল একটি এক্সক্লুসিভ বোনাস অফার করে! \"লাইভ ক্যাসিনো\" সেকশনের গেমগুলোতে বেট রাখুন এবং হারানো বেটের পরিমাণের উপর নির্ভর করে আপনার অ্যাকাউন্টে ক্যাশব্যাক পান!",
  liveCashback: "লাইভ ক্যাশব্যাক",
  liveCashbackHistory: "লাইভ ক্যাশব্যাকের ইতিহাস",
  live_casino: "লাইভ ক্যাসিনো",
  loading: "লোড হচ্ছে",
  loadingLanguage: "ভাষা লোড হচ্ছে",
  lobby: "লবি",
  login: "লগইন",
  loginCopied: "আপনার লগইন কপি করা হয়েছে",
  loginErr: "{name} লগইনে অবশ্যই বর্ণ থাকতে পারবে না!",
  loginTelegram: "টেলিগ্রাম ব্যবহার করে লগ ইন করুন",
  logoutFromSystem: "সাইন আউট করুন",
  lose: "পরাজিত",
  losers: "পরাজিত",
  lottery: "লটারি",
  mainPage: "প্রধান পেজ",
  makeABet: "বাজি ধরুন",
  makeBet: "বেট ধরুন",
  makeDeposit: "অর্থ জমা করুন",
  march: "মার্চ",
  matchClosed: "ম্যাচ শেষ হয়ে গেছে",
  matchEnded: "ম্যাচ সম্পন্ন হয়েছে",
  matchNotFound: "মিল পাওয়া যায়নি",
  matchPlanned: "ম্যাচের পরিকল্পনা করা হয়েছে",
  matches: "ম্যাচসমূহ",
  maxBet: "সর্বোচ্চ বাজি",
  maxForExpress: "অ্যাকিউমুলেটরের জন্য সর্বোচ্চ",
  maxLength: "ফিল্ডের সর্বোচ্চ দৈর্ঘ্য {length}",
  maxOutput: "অর্থ উত্তোলনের সর্বনিম্ন পরিমান",
  maxPay: "পেমেন্টের সর্বোচ্চ পরিমাণ",
  maxSum: "সর্বোচ্চ পরিমাণ",
  maxValue: "সর্বোচ্চ মান {value}",
  maxValueShort: "সর্বোচ্চ: {value}",
  maxWithdrawSum: "অর্থ উত্তোলনের সর্বোচ্চ পরিমান",
  maximumPayment: "পেমেন্টের সর্বোচ্চ পরিমাণ",
  may: "মে",
  messageSMS: "SMS -এ প্রাপ্ত কোড লিখুন",
  messages: "নতুন ম্যাসেজ",
  middleName: "নামের মধ্য অংশ",
  minBet: "সর্বনিম্ন বাজি",
  minDepositForBonus: "ধাপটি সম্পন্ন করতে ন্যূনতম {sum} অর্থ জমা করুন",
  minLength: "ফিল্ডের ন্যূনতম দৈর্ঘ্য {length}",
  minLengthPassword: "পাসওয়ার্ডে কমপক্ষে {min} টি ক্যারেক্টার থাকতে হবে",
  minOutput: "অর্থ জমার শর্ত",
  minPay: "ন্যূনতম পেমেন্টের পরিমাণ",
  minSum: "ন্যূনতম পরিমাণ",
  minValue: "সর্বনিম্ন মান {value}",
  minValueShort: "সর্বনিম্ন: {value}",
  minimalDeposit: "ন্যূনতম জমাকৃত অর্থ",
  minimalLengthOfCode: "Пожалуйста используйте {num} символов",
  minimalSum: "ন্যূনতম পরিমাণ",
  minimumPayment: "পেমেন্টের ন্যূনতম পরিমাণ:",
  minimumTransfer: "অ্যাকাউন্টে ট্রান্সফারের ন্যূনতম পরিমাণ:",
  modal_telegram: "আমাদের চ্যানেলে আপনি সক্রিয় বোনাস ও প্রোমোশন, সাপ্তাহিক ড্র ও আরও অনেক কিছু পাবেন এবং বটের কারণে আপনি কখনোই ওয়েবসাইটে অ্যাক্সেস হারাবেন না!",
  more: "আরও",
  moveToBonus: "বোনাসে যান",
  moveToMessages: "মেসেজে যান",
  myBalances: "আমার ব্যালেন্স",
  myBonuses: "আমার বোনাসসমূহ",
  name: "নাম",
  namePerson: "পুরো নাম",
  nameTheCheckout: "ক্যাশিয়ারকে ওয়ালেটের ঠিকানা বলুন",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "বেটগেমস",
    fantasy: "ফ্যান্টাসি",
    fast: "ইনস্ট্যান্ট",
    jetx: "JetX",
    line: "স্পোর্টস",
    live: "লাইভ",
    liveGames: "LiveGames37",
    lottery: "লটারি",
    online: "লাইভ ক্যাসিনো",
    slot: "স্লটস",
    sportGames: "স্পোর্টস গেম",
    table: "টেবিল",
    turboGames: "টার্বো গেম",
    vSport: "V-স্পোর্ট",
    virtualGames: "ভার্চুয়াল গেম",
    worldcup: "2022​-​বিশ্বকাপ"
  },
  navLinks: {
    bonuses: "বোনাস",
    home: "হোম",
    homeCasino: "ক্যাসিনো",
    posts: "পোস্টসমূহ",
    profile: "প্রোফাইল",
    promo: "প্রোমোশন",
    sport: "স্পোর্ট",
    tournament: "টুর্নামেন্ট"
  },
  needConfirmProfileInformation: "বোনাস সক্রিয় করতে প্রোফাইলে আপনার তথ্য নিশ্চিত করুন",
  needDeposit: "একটি আমানত করা আবশ্যক",
  needSettingsSecurity: "অনুগ্রহ করে সিকিউরিটি সেটিংস পরীক্ষা করুন",
  needToExecuteConditions: "শর্ত পূরণ করতে হবে!",
  never: "কখনোই না",
  "new": "নতুন",
  new2: "নতুন",
  newBonusAvailable: "আপনার একটি নতুন বোনাস আছে",
  newGame: "নতুন",
  newMessage: "নতুন ম্যাসেজ",
  newMessages: "নতুন ম্যাসেজ",
  newOne: "নতুন",
  newVersionReloadPage: "সাইটের সংস্করণ আপডেট করা হয়েছে, সঠিক অপারেশনের জন্য পেজটি রিফ্রেশ করুন",
  newYearPromocodes2025: {
    NY25DAY1: "Santa's Gift গেম এ 50 FS",
    NY25DAY10: "স্পোর্টস​•​এর​•​জন্য​•​ফ্রিবেট!",
    NY25DAY11: "Santa's Great Gifts গেম এ 50 FS",
    NY25DAY12: "Royal Xmass 2 গেম এ 75 FS",
    NY25DAY13: "75% ডিপোজিট এবং 75 FS উপহার হিসাবে!",
    NY25DAY14: "Santa's Xmas Rush গেম এ 100 FS",
    NY25DAY2: "স্পোর্টস​•​এর​•​জন্য​•​ফ্রিবেট!",
    NY25DAY3: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!",
    NY25DAY4: "Buffalo Power: Christmas গেম এ 75 FS",
    NY25DAY5: "75% ডিপোজিট এবং 75 FS উপহার হিসাবে!",
    NY25DAY6: "Royal Xmass গেম এ 75 FS",
    NY25DAY7: "100% ডিপোজিট এবং 100 FS উপহার হিসাবে!",
    NY25DAY8: "Sugar Rush Xmas গেম এ 100 FS",
    NY25DAY9: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!"
  },
  next: "পরবর্তী",
  nextGames: "আরো দেখান",
  no: "না",
  noAccount: "কোনো অ্যাকাউন্ট নেই",
  noBetsInHistory: "আপনার ইতিহাসে কোনো বেট নেই",
  noConnectionTryAlready: "ইন্টারনেট সংযোগ নেই। ইন্টারনেটে যুক্ত হন এবং আবার চেষ্টা করুন।",
  noDeposit: "কোন জমা নেই",
  noFavoritesYet: "এখন পর্যন্ত পছন্দের কিছুই নাই",
  noMatchSelected: "কোনো ইভেন্ট বাছাই করা হয়নি বা লাইন খালি!",
  noResults: {
    bets: "আপনার বেট এখানে প্রদর্শিত হবে",
    bonuses: "এভেইলেবল বোনাস এখানে প্রদর্শিত হবে",
    competitions: {
      active: "সক্রিয় টুর্নামেন্ট এখানে প্রদর্শিত হবে",
      all: "সক্রিয় টুর্নামেন্ট এখানে প্রদর্শিত হবে",
      ended: "আগের টুর্নামেন্ট এখানে প্রদর্শিত হবে",
      future: "ভবিষ্যৎ টুর্নামেন্ট এখানে প্রদর্শিত হবে"
    },
    gamesNotFound: "কোনো গেম পাওয়া যায়নি",
    gamesSearch: "আপনার অনুরোধ অনুযায়ী কোনো গেম পাওয়া যায়নি, অনুগ্রহ করে আরেকটি অনুরোধ চেষ্টা করুন",
    messages: "আপনার ম্যাসেজ এখানে প্রদর্শিত হবে",
    payin: "আপনার কাছে জমার পদ্ধতি এভেইলেবল নেই",
    payout: "আপনার কাছে উত্তোলনের পদ্ধতি এভেইলেবল নেই",
    simple: "কোনো ফলাফল নেই",
    transactions: "আপনার লেনদেন এখানে প্রদর্শিত হবে",
    withdraw: "আপনার উত্তোলনের অনুরোধ এখানে প্রদর্শিত হবে"
  },
  noSelectionsForBetting: "বেটিং-এর জন্য কোন নির্বাচিত ফলাফল নেই",
  nomination: "টুর্নামেন্টে মনোনয়ন",
  nonBonusGame: "গেমটি বোনাস প্রোগ্রামে অংশগ্রহণ করে না। আমরা আপনাকে প্রধান অ্যাকাউন্টে স্যুইচ করে দিবো।",
  nonBonusGameBetsNotCountInVager: "এই গেমটি বোনাস প্রোগ্রামে অংশগ্রহণ করে না। বোনাসের বেটগুলো সাধারণ বেটের সাথে ধরা হয় না",
  nonBonusGameWithoutBalance: "গেমটি বোনাস প্রোগ্রামে অংশগ্রহণ করে না। খেলতে হলে আপনার প্রধান অ্যাকাউন্টে অর্থ জমা করুন।",
  notBonuses: "সক্রিয় কোনো বোনাস নেই",
  notCompetition: "সক্রিয় কোনো টুর্নামেন্ট নেই",
  notConfirmed: "কনফার্ম করা হয়নি",
  notDeposit: "কোনো অর্থ জমা হয়নি",
  notEnoughEventsForExpress: "সঞ্চয়কারীর জন্য যথেষ্ট ইভেন্ট নয়",
  notEnoughEventsForSystem: "সিস্টেমের জন্য যথেষ্ট ইভেন্ট নেই",
  notEnoughMoneyToWithdraw: "উত্তোলনের জন্য পর্যাপ্ত অর্থ নেই",
  notEnoughVventsForSystem: "সিস্টেমের জন্য যথেষ্ট ইভেন্ট নেই",
  notInterested: "আগ্রহী নই",
  notLogin: "আপনার {name} লগইন লিখুন!",
  notNow: "এখন নয়",
  notPass: "পাসওয়ার্ড লিখুন!",
  notSufficient: "পর্যাপ্ত নয়",
  notValidValue: "মান সঠিক নয়",
  notification: "নোটিফিকেশন",
  november: "নভেম্বর",
  nowInLine: "এখন স্পোর্টসে",
  nowPlayed: "এখন বাজি ধরা হয়েছে",
  numberErr: "অনুগ্রহ করে নিবন্ধনের সময় প্রদত্ত নম্বরটি চেক করুন",
  numberOfWallet: "ওয়ালেট​•​নম্বর",
  october: "অক্টোবর",
  onAccountBK: "বুকমেকারের অ্যাকাউন্টে",
  oneClick: "এক ক্লিকে পট বহুগুণ করুন",
  online: "অনলাইন",
  onlyForYou: "শুধুমাত্র আপনার জন্য",
  open: "ওপেন করুন",
  openAppTrustWallet: "অ্যাপটি খুলুন। আপনি দুটি অপশনে প্রবেশ করতে পারবেন: নতুন ওয়ালেট নিবন্ধন বা একটি বিদ্যমান ওয়ালেট পুনরুদ্ধার করতে নতুন ওয়ালেট তৈরি বোতামে ক্লিক করুন।",
  openEmail: "ইমেইল খুলুন",
  openGameNewTab: "গেমটি ওপেন করতে বাটনে ক্লিক করুন",
  openSafari: "Safari তে খুলুন",
  openSafariIfAnotherBrowser: "আপনি যদি অন্য কোনো ব্রাউজারে থাকেন, Safari তে এই পেজটি খুলুন",
  openTelegramBot: "টেলিগ্রাম বট ওপেন করুন",
  operations: "অপারেশন",
  orders: "অর্ডারসমূহ",
  ordinary: "একক",
  ordinarySeries: "একক বাজি সিরিজ",
  other: "অন্যান্য",
  otherSections: "অন্যান্য​•​বিভাগ",
  ourSocialMedia: "আমাদের সোশ্যাল নেটওয়ার্ক",
  ourSocialMediaShort: "আমাদের সোশ্যাল নেটওয়ার্ক",
  out: "প্রস্থান করুন",
  output: "অর্থ উত্তোলন করা",
  outputModalTitle: "প্রত্যাহার নিশ্চিতকরণ",
  outputSuccess: "অর্থ উত্তোলন সফলভাবে সম্পন্ন হয়েছে!",
  overallCoef: "সামগ্রিক ওডস",
  page: "পেজ",
  pageErr: "পেজ পাওয়া যায়নি",
  pageErrDesc: "পৃষ্ঠা মুছে ফেলা হয়েছে বা ঠিকানা ভুলভাবে প্রবেশ করানো হয়েছে",
  pageNotFound: "পৃষ্ঠা খুঁজে পাওয়া যায়নি!",
  pageNotFoundDesc: "পৃষ্ঠা মুছে ফেলা হয়েছে বা ঠিকানা ভুলভাবে প্রবেশ করানো হয়েছে",
  participant: "অংশগ্রহণকারী",
  participate: "অংশগ্রহণ করুন",
  passErr: "আপনার পাসওয়ার্ড ভুলে গেছেন?",
  passMessage: "পাসওয়ার্ডে অবশ্যই সংখ্যা, বড় হাতের ও ছোট হাতের অক্ষর থাকতে হবে",
  passportIndex: "জাতীয় পরিচয়পত্র নম্বর",
  password: "পাসওয়ার্ড",
  passwordChanged: "পাসওয়ার্ড পরিবর্তন হয়েছে",
  passwordErr: "এখন যোগ দিন",
  passwordNew: "নতুন পাসওয়ার্ড",
  passwordSuccess: "পাসওয়ার্ড সফলভাবে পুনরুদ্ধার করা হয়েছে",
  passwordTheSame: "আপনার নতুন পাসওয়ার্ড বর্তমানের থেকে আলাদা হতে হবে",
  past: "অতীত",
  pay: "পেআউট",
  payBonusErr: "কোনো বোনাস ক্রয় করতে, অন্তত যে পরিমাণে অর্থ জমা করতে হবে",
  payMethod: "অর্থ জমা করার পদ্ধতি",
  payMethods: "অর্থ জমা করার পদ্ধতিসমূহ",
  paymentMethod: "পেমেন্টে পদ্ধতি:",
  paymentSuccess: "সফলভাবে অর্থ ট্রান্সফার  সম্পন্ন হয়েছে!",
  payoutPayTrxsExistsText: "অর্থ উত্তোলন করতে, অনুগ্রহ করে অন্তত একবার অর্থ জমা করুন",
  payoutThresholdStatusText: "অর্থ উত্তোলন করতে, অনুগ্রহ করে {count} বাজি ধরুন",
  period: "সময়কাল",
  personInformationIsApprove: "তথ্য গৃহীত, অ্যাকাউন্ট সুরক্ষিত",
  personalArea: "ব্যক্তিগত অ্যাকাউন্ট",
  personalData: "ব্যক্তিগত ডেটা",
  personalDataApproved: "ব্যক্তিগত ডেটা যাচাই করা হয়েছে",
  personalDataIsFilled: "ব্যক্তিগত তথ্যের বিবরণী পূরণ করা হয়েছে",
  personalDataSuccessfullyEdited: "আপনার ব্যক্তিগত ডেটা সফলভাবে পরিবর্তন করা হয়েছে",
  phone: "ফোন",
  phoneErr: "ফোন নম্বরে অক্ষর থাকতে পারবে না!",
  phoneNum: "ফোন নম্বর",
  phoneSuccessfullyApproved: "ফোন সফলভাবে নিশ্চিত করা হয়েছে।",
  pickUpBonus: "বোনাস পান",
  place: "অবস্থান",
  placeAQuickBet: "একটি দ্রুত বাজি রাখুন?\n",
  places: "পুরস্কারের অবস্থান:",
  placesCount: "{count} অবস্থান",
  placesPrice: "পুরস্কার",
  play: "খেলুন",
  playAviator: "Aviator খেলুন",
  playBonus: "অভিনন্দন, আপনি বোনাস বাজি ধরেছেন! ব্যালেন্সে {count} অর্থ জমা করার পর উত্তোলন করা যাবে",
  playBonusEnded: "বোনাস শেষ। গেম চালিয়ে যেতে আপনার অ্যাকাউন্ট {count} অর্থ জমা করুন",
  playForMoney: "অর্থের জন্য খেলুন",
  playGamesInCategoryes: "বিভাগ থেকে গেম খেলুন",
  playWithoutBonus: "বোনাস ছাড়া খেলুন",
  playingInAppMoreConvenient: "অ্যাপে খেলা অধিক সুবিধাজনক",
  pleaseConfirmAgreementToTheTerms: "শর্তাবলী সঙ্গে আপনার সম্মতি নিশ্চিত করুন",
  pleaseConfirmInformation: "অনুগ্রহ করে তথ্য দিয়ে নিশ্চিত করুন",
  pleaseSelectOutcome: "দয়া করে ফলাফল নির্বাচন করুন",
  pleaseUseNumberOfCharacters: "অনুগ্রহ করে {num} টি অক্ষর ব্যবহার করুন",
  point: "পয়েন্ট",
  points: "কোনো পয়েন্ট নেই | {n} | পয়েন্ট | {n} | পয়েন্ট | {n} | পয়েন্ট",
  postSMS: "SMS কোড পাঠান",
  posts: "ম্যাসেজ",
  potentialWin: "সম্ভাব্য জয়ের অর্থ",
  ppenFullBetHistory: "সম্পূর্ণ বাজির ইতিহাস খুলুন",
  preparedForRemoval: "অর্থ উত্তোলনের জন্য প্রস্তুত (প্রক্রিয়াকরণ হচ্ছে)",
  preview: "প্রিভিউ",
  prize: "পুরস্কার",
  prizes: "বিজয়ীর পুরস্কার",
  proceed: "এগিয়ে যান",
  processDeposit: "অর্থ জমা প্রক্রিয়া করা হচ্ছে",
  processDepositDescription: "পেমেন্ট পাঠানো হয়েছে এবং পেমেন্ট সিস্টেম দ্বারা প্রক্রিয়া করা হচ্ছে। অর্থ জমা করার সময়কাল কয়েক মিনিট থেকে কয়েক দিন পর্যন্ত হতে পারে",
  processWagerFromBonusBalance: "বোনাস ব্যালেন্স থেকে বাজির শর্ত পূরণ",
  processWagerFromDeposit: "জমার অর্থ থেকে বাজির শর্ত পূরণ",
  processed: "প্রক্রিয়া করা হচ্ছে",
  processing: "প্রক্রিয়া করা হচ্ছে",
  promo: "প্রোমোশন",
  promoCodeActivationSuccess: "প্রচার কোড সফলভাবে সক্রিয় করা হয়েছে",
  promoGames: "বোনাস গেম",
  promoMaxBetExceeded: "সর্বোচ্চ বাজির পরিমাণ যা বাজি ধরার জন্য ব্যবহার করা হবে {bet}{currency}",
  promoNotFound: "সক্রিয় কোনো প্রোমোশন নেই",
  promocode: {
    activate: "প্রোমোকোড সক্রিয় করুন",
    placeholder: "প্রোমোকোড",
    title: "প্রোমোকোড সক্রিয়করণ"
  },
  promocodes: {
    NY25DAY1: "Santa's Gift গেম এ 50 FS",
    NY25DAY10: "Santa's Great Gifts গেম এ 50 FS",
    NY25DAY11: "স্পোর্টস​•​এর​•​জন্য​•​ফ্রিবেট!",
    NY25DAY12: "Royal Xmass 2 গেম এ 75 FS",
    NY25DAY13: "৭৫% ডিপোজিট এবং ৭৫ FS উপহার হিসাবে!",
    NY25DAY14: "Santa's Xmas Rush গেম এ 100 FS",
    NY25DAY2: "50 ডিপোজিট এবং 50 FS উপহার হিসাবে!",
    NY25DAY3: "স্পোর্টস এর জন্য ফ্রিবেট!",
    NY25DAY4: "Buffalo Power: Christmas গেম এ 75 FS",
    NY25DAY5: "৭৫% ডিপোজিট এবং ৭৫ FS উপহার হিসাবে!",
    NY25DAY6: "Royal Xmass গেম এ 75 FS",
    NY25DAY7: "100% ডিপোজিট এবং 100 FS উপহার হিসাবে!",
    NY25DAY8: "Sugar Rush Xmas গেম এ 100 FS",
    NY25DAY9: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!",
    NYDAY1: "Hell Hot 100 গেম এ 50 FS",
    NYDAY10: "Santa's Great Gifts এ 50 FS",
    NYDAY11: "স্পোর্টস এর জন্য ফ্রিবেট!",
    NYDAY12: "Aviator এ ফ্রিবেটস",
    NYDAY13: "৭৫% ডিপোজিট এবং ৭৫ FS উপহার হিসাবে!",
    NYDAY14: "Sugar Rush Xmas গেম এ 100 FS",
    NYDAY2: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!",
    NYDAY3: "স্পোর্টস এর জন্য ফ্রিবেট!",
    NYDAY4: "JetX এ ফ্রিবেটস",
    NYDAY5: "৭৫% ডিপোজিট এবং ৭৫ FS উপহার হিসাবে!",
    NYDAY6: "Twin fruits of Santa গেম এ ৭৫ FS",
    NYDAY7: "100% ডিপোজিট এবং 100 FS উপহার হিসাবে!",
    NYDAY8: "Sugar Rush Xmas গেম এ 100 FS",
    NYDAY9: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!"
  },
  promocodes2025: {
    NY25DAY1: "Santa's Gift গেম এ 50 FS",
    NY25DAY10: "স্পোর্টস​•​এর​•​জন্য​•​ফ্রিবেট!",
    NY25DAY11: "Santa's Great Gifts গেম এ 50 FS",
    NY25DAY12: "Royal Xmass 2 গেম এ 75 FS",
    NY25DAY13: "75% ডিপোজিট এবং 75 FS উপহার হিসাবে!",
    NY25DAY14: "Santa's Xmas Rush গেম এ 100 FS",
    NY25DAY2: "স্পোর্টস​•​এর​•​জন্য​•​ফ্রিবেট!",
    NY25DAY3: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!",
    NY25DAY4: "Buffalo Power: Christmas গেম এ 75 FS",
    NY25DAY5: "75% ডিপোজিট এবং 75 FS উপহার হিসাবে!",
    NY25DAY6: "Royal Xmass গেম এ 75 FS",
    NY25DAY7: "100% ডিপোজিট এবং 100 FS উপহার হিসাবে!",
    NY25DAY8: "Sugar Rush Xmas গেম এ 100 FS",
    NY25DAY9: "50% ডিপোজিট এবং 50 FS উপহার হিসাবে!"
  },
  promotionNotFound: "There is no such promotion",
  protectYouData: "আপনার ব্যক্তিগত তথ্য এবং তহবিল সুরক্ষিত করুন",
  protection: "গোপনীয়তা সম্পর্কিত নীতিমালা",
  protectionSettingsMessage: "আপনার তহবিল সুরক্ষিত করতে এবং সেগুলি নিরাপদে তোলার জন্য অ্যাকাউন্ট সুরক্ষা সেটিংস প্রয়োজনীয়৷",
  providers: "প্রোভাইডারগণ",
  purchaseCryptocurrency: "ক্রিপ্টোকারেন্সি ক্রয়",
  putSend: "কোড পান",
  queue: "সারিতে",
  reSendCode: "পুনরায় পাঠানো কোড",
  read: "পড়ুন",
  readyForWithdrawOnCashier: "ক্যাশ ডেস্কে পেমেন্টের জন্য প্রস্তুত",
  receiveWithdrawalConfirmation: "ই-মেইল/টেলিগ্রামের মাধ্যমে অর্থ উত্তোলনের কনফার্মেশন পান",
  recomend: "আপনার জন্য প্রস্তাবিত",
  recovery: "পাসওয়ার্ড পুনরুদ্ধার",
  recoveryEmailDesc: "আপনার অ্যাকাউন্টে প্রবেশ করতে হলে নিবন্ধনের সময় আপনার দেওয়া ই-মেইলটি লিখুন",
  recoveryPassword: "পাসওয়ার্ড পুনরুদ্ধার করুন",
  recoveryPhoneDesc: "আপনার অ্যাকাউন্টে প্রবেশ করতে হলে নিবন্ধনের সময় আপনার দেওয়া ফোন নম্বরটি লিখুন",
  recoveryWord: "পুনরুদ্ধার",
  refill: "অর্থ জমা করুন",
  refresh: "রিফ্রেশ করুন",
  refreshPage: "পেজটি রিফ্রেশ করুন",
  refund: "রিফান্ড",
  refundPolicy: "রিফান্ডের নীতিমালা",
  refundWithdrawal: "প্রত্যাহার বাতিল করুন",
  refundWithdrawalModalDesc: "Are you sure you want to cancel withdrawal of funds? If canceled, the funds will be returned to the main balance.",
  refundWithdrawalNoun: "প্রত্যাহার বাতিল",
  reg: "নিবন্ধন",
  register: "এখন যোগ দিন",
  registrationBonus: "রেজিস্ট্রেশনের জন্য বোনাস",
  rejected: "প্রত্যাখ্যান",
  remainingPlay: "বাজি ধরার জন্য বাকি আছে",
  repeatPassword: "পাসওয়ার্ড পুনরাবৃত্তি করুন",
  repeatTopUpDesc: "পেমেন্ট ব্যর্থ? আমরা কি আবার চেষ্টা করব?",
  replenishment: "অর্থ জমা করুন",
  requirement: "যা যা প্রয়োজন",
  requisiteDesc: "টাকা জমা করার জন্য আপনার আকাউন্ত এ অর্থ {Sum}  ট্রান্সফার করুন। একটি সফল ডিপোজিট এর জন্য আপনার ট্রান্সফার করা অর্থের পরিমাণ এবং ডিপোজিট এর অর্থের পরিমাণ এর সাথে সম্পূর্ণ মিল থাকতে হবে।",
  resend: "আবার পাঠান",
  resendCodeCanAfter: "কোডটি {0}-এর মধ্যে পুনরায় পাঠানো যাবে",
  reset: "রিসেট করুন",
  resetFilters: "ফিল্টার রিসেট করুন",
  resetIt: "এটি পুনরায় সেট করুন",
  responsibleGame: "দায়িত্বশীল গেমিং",
  result: "ফলাফল",
  results: "ফলাফল",
  resultsSearch: "অনুসন্ধান এর ফলাফল",
  "return": "রিফান্ড",
  rollback: "রোলব্যাক",
  rules: "শর্তাবলী",
  rulesDescription: "নিয়মাবলী",
  rulesShort: "নিয়মাবলী",
  rulesTournament: "টুর্নামেন্টের শর্তাবলী এবং নিয়মাবলী",
  russian: "রাশিয়ান",
  sales: "নগদ করা হয়েছে",
  save: "সেভ করুন",
  schedule: "সময়সূচি",
  scores: "পয়েন্ট",
  search: "খুঁজুন",
  searchProviders: "সরবরাহকারির নাম",
  seats: "অবস্থান",
  secretAnswer: "নিরাপত্তা প্রশ্নের উত্তর",
  secretQuestion: "গোপন প্রশ্ন",
  security: {
    five: "আপনার ডেটা সুরক্ষা সম্পর্কে এখনও কোনো প্রশ্ন থাকলে অনুগ্রহ করে অনলাইন সাপোর্ট সার্ভিসের সাথে যোগাযোগ করুন বা {support}-এ একটি ইমেইল পাঠান। আমরা আপনাকে সহায়তা করতে পেরে আনন্দিত হব।",
    one: "আমরা এই ডেটা-সুরক্ষা বিধানগুলো প্রকাশ করছি যাতে দেখা যায় যে আমরা বিশ্বব্যাপী মান অনুযায়ী ব্যবসা করতে প্রতিশ্রুতিবদ্ধ।",
    seven: "তথ্যের সুরক্ষা",
    six: "ওয়েবসাইটের পরিষেবা এবং তথ্য \"Euromirbet d.o.o.\", Podgorica, Cetinjski put bb, রেজি: 5-0685623/1 কোম্পানি দ্বারা সরবরাহ করা হয়। পেমেন্ট কার্ড শিল্পের নিরাপত্তা মান নির্ধারণকারী কাউন্সিলের সুপারিশ অনুযায়ী গ্রাহকের ডেটা রক্ষা করার জন্য পরিবহন স্তরে এনক্রিপশন ব্যবহার করা হয় - TLS 1.2 এবং অ্যাপ্লিকেশন স্তরে AES অ্যালগরিদম, যার কী-এর দৈর্ঘ্য 256 বিট",
    three: "{titlePure}-এর একটি স্প্যাম বিরোধী নীতি আছে আমাদের প্লেয়ারদের পাঠানো সকল ইমেইল তাদের গেমিং অ্যাকাউন্টের সাথে সম্পর্কিত, এবং ক্যাসিনোতে তাদের নতুন বৈশিষ্ট্য ও প্রাসঙ্গিক প্রোমোশোনাল কনটেন্ট সম্পর্কেও তথ্য থাকতে পারে। বিজ্ঞাপনের মেইল পাঠানোর হার পরিবর্তিত হতে পারে এবং প্রতিদিন 3টি পত্র পর্যন্ত পৌঁছাতে পারে। প্লেয়াররা আনসাবস্ক্রাইব করার অধিকার সংরক্ষণ করেন - এই ক্ষেত্রে, আপনাকে অবশ্যই অনলাইন সাপোর্ট সার্ভিসের সাথে যোগাযোগ করতে হবে বা চিঠির নিচে উপযুক্ত লিংকে ক্লিক করে যেকোনো সময় আনসাবস্ক্রাইব করতে পারেন। আপনার জয়ের অর্থ ও আপনার করা পেমেন্টের তথ্যও কঠোরভাবে গোপনীয় এবং একটি নিরাপদ পরিবেশে সংরক্ষণ করা হয়।",
    two: "আমরা বিশ্বাস করি যে ভালো ব্যবসায়িক সম্পর্ক শুধুমাত্র সততা ও বিশ্বাসের উপর নির্মিত হয়। একারণে, আপনার তথ্যের গোপনীয়তা আমাদের কাছে অত্যন্ত গুরুত্বপূর্ণ। আপনার লেনদেনের নিরাপত্তা নিশ্চিত করার জন্য আমরা সকল ধরনের ব্যবস্থা গ্রহণ করি তা জেনে আপনি গেমটি উপভোগ করতে পারেন। আপনার নাম, ডাক ঠিকানা, ই-মেইল ঠিকানা, ফোন নম্বর, জন্ম তারিখ, লিঙ্গ, আইপি ঠিকানা এবং অন্যান্য তথ্য ব্যক্তিগত ও গোপনীয় এবং তৃতীয় পক্ষের কাছে ট্রান্সফার, বিক্রি বা বিতরণ করা যাবে না।"
  },
  securityAnswer: "নিরাপত্তাসূচক উত্তর",
  securityQuestion: "নিরাপত্তাসূচক প্রশ্ন",
  securitySetting: "নিরাপত্তা সেটিং\n",
  selectAll: "সবগুলো নির্বাচন করুন",
  selectApproveMethod: "একটি অর্থ উত্তোলন কনফার্মেশন পদ্ধতি বেছে নিন",
  selectCountryToReceive: "এই অঞ্চলে বর্তমান অফার এবং শর্তাবলী পেতে একটি দেশ নির্বাচন করুন৷",
  selectPaymentCurrencyAndClickTopUpAccount: "পেমেন্ট মুদ্রা নির্বাচন করুন এবং \"ডিপোজিট\" ক্লিক করুন",
  selectProviders: "নির্বাচিত প্রোভাইডারদের সকল গেম",
  selectQuestion: "প্রথমে একটি প্রশ্ন নির্বাচন করুন",
  selectVariable: "উপযুক্ত অপশনটি নির্বাচন করুন",
  sellBet: "নগদ করুন",
  send: "পাঠান",
  sendCode: "কোড পাঠান",
  sendCodeError: "কোড প্রবেশ করানো যাচ্ছে না, অনুগ্রহ করে যোগাযোগ করুন",
  sendCodeErrorSupport: "সাপোর্ট",
  sendCodeRepeat: "আবার কোড পাঠান",
  sendCodeSuccess: "ফোনে কোড পাঠানো হয়েছে",
  sendCodeSuccessEmail: "ইমেইলে কোড পাঠানো হয়েছে",
  sendConfirmationEmail: "আমরা এই ঠিকানায় একটি কনফার্মেশন ইমেইল পাঠিয়েছি",
  sendConfirmationPhone: "আমরা নম্বরে {phone} একটি কোডসহ একটি SMS পাঠিয়েছি",
  sendDocuments: "ডকুমেন্টস পাঠান",
  sendSMS: "SMS কোড পাঠান",
  sendedCodeToEmail: "কোড টি আপনার ইমেইলে পাঠানো হয়েছে <br> {email}",
  sendedCodeToPhone: "কোড টি আপনার ফোনে পাঠানো হয়েছে <br> {phone}",
  september: "সেপ্টেম্বর",
  serverErrorTryAgain: "সার্ভারে ত্রুটি, অনুগ্রহ করে আবার চেষ্টা করুন",
  serverErrorTryRefresh: "সার্ভারে ত্রুটি, আপডেট করার চেষ্টা করে দেখুন",
  settlementCurrency: "নিষ্পত্তির মুদ্রা",
  sgtv_bonus: {
    block_one_li_four: "10টি ফ্রি বেট পান।",
    block_one_li_one: "বোনাস পেতে হলে আপনার ব্যালেন্সে অন্তত {sum} {currency} থাকতে হবে।",
    block_one_li_three: "লবিতে বোনাস সক্রিয় করুন।",
    block_one_li_two: "বোনাস সক্রিয় করতে, যেকোনো SGTV গেমে যান।",
    block_one_title: "কীভাবে আপনার বোনাস পাবেন:",
    block_two_li_eight: "বোনাস পাওয়ার জন্য একবার 20x বাজি ধরতে হবে। বাজি ধরার সর্বনিম্ন অডস হলো 1.5।",
    block_two_li_eleven: "Olymp অফারটির শর্তাবলী পৃথকভাবে এবং যেকোনো সময়ে পরিবর্তন বা বাতিল করার এবং সেইসাথে ব্যাখ্যা ছাড়াই যেকোনো প্লেয়ারকে প্রত্যাখ্যান করার অধিকার সংরক্ষণ করে।",
    block_two_li_five: "স্পোর্টস গেম সেকশনে প্রবেশ করার সময় নতুন প্লেয়ারকে {sum} {currency} সমমানের 10টি ফ্রি বেট দেওয়া হয়।",
    block_two_li_four: "বোনাস সঙ্গে সঙ্গে যোগ করা হয়। নির্বাচিত বোনাস যোগ করা না হলে, গেম শুরু করার আগে আপনাকে অবশ্যই কাস্টোমার সার্ভিসের সাথে যোগাযোগ করতে হবে। আপনি যদি বোনাস ছাড়া গেমটি শুরু করেন তবে এটি আর জমা হবে না।",
    block_two_li_nine: "নো-ডিপোজিট ফ্রি বেট ও নো-ডিপোজিট বোনাস থেকে উত্তোলনের জন্য পাওয়া জয়ের অর্থের সর্বাধিক পরিমাণ হল - {sum} {currency}।",
    block_two_li_one: "ব্যবহারকারীরা শুধুমাত্র একবার বোনাস পাওয়ার অধিকার রাখেন।",
    block_two_li_seven: "সক্রিয় হওয়ার মুহূর্ত থেকে 3 দিনের মধ্যে বোনাস পাওয়া যায়।",
    block_two_li_six: "ফ্রি বেট «Boxing», «Darts», «Bridge», «Shootouts», ও «Nards» গেমসে ব্যবহার করা যায়।",
    block_two_li_ten: "1.3 থেকে 5 অডসের বেটে ফ্রি বেট ব্যবহার করা যায়",
    block_two_li_three: "বোনাস পাওয়ার জন্য আপনার {sum} {currency} পরিমাণ জমা করতে হবে।",
    block_two_li_two: "বোনাস (ফ্রি বেট) সেই প্লেয়ারদের দেওয়া হয় যারা SportgamesTV-তে কখনও বেট ধরেনি।",
    block_two_title: "শর্তাবলী:",
    important_text: "গুরুত্বপূর্ণ! আপনি যদি বোনাস সক্রিয় না করে গেমটি শুরু করেন তবে ফ্রি বেট পরে যোগ করা হবে না।",
    title: "SportGamesTV-তে নতুন প্লেয়ারদের জন্য ফ্রি বেট! \"Nards\", \"Boxing\", \"Darts\", \"Bridge\", \"Shootouts\" গেমে 10টি ফ্রি বেট লুফে নিন।"
  },
  shallWePlay: "আমরা কি খেলা শুরু করবো?",
  shortDescription: "সংক্ষিপ্ত বিবরণ",
  show: "দেখান",
  showAll: "সবগুলো দেখুন",
  showBets: "বেট দেখান",
  showCodeOnlyForOperator: "ক্যাশিয়ার ছাড়া কাউকে কনফার্মেশন কোড দেবেন না",
  showGame: "গেম দেখান",
  showGames: "গেমগুলো দেখান",
  showMatchesStarting: "এই সময়ে শুরু হওয়া ম্যাচ দেখান:",
  showMoreGames: "আরো গেম দেখান",
  showTerms: "শর্তাবলী দেখান",
  showTransactions: "লেনদেন দেখান",
  signUp: "সাইন আপ করুন",
  signUpAndVerifyVolet: "সাইন আপ করুন এবং 15 মিনিটের মধ্যে যাচাইকরণ প্রক্রিয়া সম্পন্ন করুন",
  signin: "লগ ইন করুন",
  silver: "সিলভার",
  slots: "স্লটস",
  smallDescription: "টুর্নামেন্টের সংক্ষিপ্ত বিবরণ",
  smsCode: "SMS-এ কোড পান",
  smsInfo: "আপনার নম্বরে একটি SMS-এর মাধ্যমে কোড পাঠানো হবে",
  smsSendingDesc: "আপনার নম্বরে আমরা যে কোডটি পাঠিয়েছি সেটি লিখুন",
  smsVer: "SMS-এর মাধ্যমে পেমেন্ট যাচাইকরণ",
  smsVerDisabled: "SMS-এর মাধ্যমে পেমেন্ট যাচাইকরণ নিষ্ক্রিয় করা হয়েছে",
  smsVerEnabled: "SMS-এর মাধ্যমে পেমেন্ট যাচাইকরণ সক্রিয় করা হয়েছে",
  socialAuthError: "সামাজিক নেটওয়ার্কের মাধ্যমে অনুমোদনের সময় ত্রুটি",
  soonStarted: "খুব শীঘ্রই শুরু হবে",
  sort: "সাজান",
  spaceNotAvailableForField: "এই ঘরে স্পেস দেওয়া যাবে না",
  specifyNumberYourPersonalCryptoWallet: "ক্ষেত্রে, ওয়েবসাইটে আপনার ব্যক্তিগত ক্রিপ্টো ওয়ালেটের নম্বর লিখুন",
  spinsBeforeCrediting: "জমা করার আগে স্পিনের সংখ্যা:",
  sportErrorText: "আমরা বর্তমানে \"স্পোর্টস\" সেকশনটি আপডেট করছি, তবে আমরা শীঘ্রই সবকিছু আগের মত করে ফেলব।",
  sports: "স্পোর্টস",
  stakeHasBeenSuccessfully: "আপনার বাজি সফলভাবে গৃহীত হয়েছে!",
  startSecuritySetup: "নিরাপত্তা সেটআপ পাস করুন",
  stateOfAnAccount: "অ্যাকাউন্টের অবস্থা",
  status: "স্ট্যাটাস",
  statusAcc: "অ্যাকাউন্টের স্ট্যাটাস:",
  statusOfTransaction: "লেনদেনের অবস্থা",
  statusSuccess: "নিশ্চিত করা হয়েছে",
  statuses: {
    calculationInProgress: "নিষ্পত্তি চলছে",
    inProcess: "প্রক্রিয়াধীন",
    notPayed: "পে করা হয়নি",
    payed: "পে করা হয়েছে"
  },
  sub_telegram: "টেলিগ্রামে সাবস্ক্রাইব করুন",
  success: "কাজটি সফল হয়েছে",
  successEnterTournament: "দুর্দান্ত, আপনি টুর্নামেন্টে আছেন!",
  successPromoCode: "প্রচার কোড সফলভাবে সক্রিয় করা হয়েছে৷",
  sufficient: "পর্যাপ্ত",
  sum: "মোট",
  sumBet: "বেটের পরিমাণ",
  sumMoreThanBalance: "ব্যালেন্সের চেয়ে পরিমাণ বেশি",
  sumWithdraw: "পেআউটের পরিমাণ",
  support: "সাপোর্ট",
  supportContact: "সহায়তার সাথে যোগাযোগ করুন\n",
  surname: "নামের শেষ অংশ",
  suspended: "স্থগিত",
  system: "সিস্টেম",
  table: "টেবিল",
  tapOnHome: "\"হোম\" এ ট্যাপ করুন, এবং তারপর \" শেষ \" ক্লিক করুন",
  tapOnShareIcon: "স্ক্রিনের নিচের মেনুতে \"শেয়ার\" আইকনে ট্যাপ করুন। একটি ডায়লগ বক্স খুলবে",
  term: "অর্থ জমার শর্ত",
  termEnrollment: "অর্থ জমার শর্ত",
  termFulfillment: "শর্ত পূরণের মেয়াদ:",
  termsAndConditions: "শর্তাবলী",
  termsAndConditionsList: "শর্তাবলী",
  timeFulfill: "শর্ত পূরণের সময়:",
  timeRemaining: {
    txt: "কোডটি আবার নিতে {seconds} সেকেন্ড বাকি আছে",
    txtPay: "আপনি {seconds}-এর মধ্যে একটি নতুন কোড নিতে পারেন"
  },
  timeToActivateBonus: "বোনাস সক্রিয়করণের সময়",
  timer: {
    oneLetter: {
      day: "d",
      hour: "h",
      minute: "m",
      second: "s"
    },
    "short": {
      day: "দিন.",
      hour: "ঘন্টা।",
      minute: "মিনিট.",
      second: "সেকেন্ড."
    }
  },
  tip: "পরামর্শ",
  titles: {
    cashback: "ক্যাশব্যাক",
    dropsWins: "ড্রপস অ্যান্ড উইনস",
    err404: "অনুরোধ করা পেজটি নেই",
    fraud: "জালিয়াতি থেকে সুরক্ষা",
    gameGroups: {
      "GamesByGroup\/slot": "স্লট অনলাইন - অর্থের জন্য স্লট মেশিন খেলুন, নিবন্ধন ছাড়াই বিনামূল্যে"
    },
    home: "{titlePure}",
    profile: "প্রোফাইল",
    protection: "তথ্যের সুরক্ষা",
    responsibleGame: "দায়িত্বশীল গেমিং",
    rules: "শর্তাবলী",
    tournaments: "টুর্নামেন্ট",
    work: "কারিগরি কাজ চলছে"
  },
  to: "{date}-তে",
  toFindOutWalletAddressOfCoin: "কোনো কয়েনের ওয়ালেট ঠিকানা জানার জন্য, প্রধান স্ক্রিনে পছন্দের কয়েনে ক্লিক করুন। কয়েনের পেজে লেনদেনের ইতিহাস দেখা যাবে",
  toPromoStart: "প্রমোশন শুরুর আগে",
  toSupport: "সাপোর্ট",
  topLines: "শীর্ষ স্পোর্টস",
  topUp: "অর্থ জমা করুন",
  topUpWith: "যার মাধ্যমে জমা",
  topupYourBalance: "অর্থের জন্য খেলতে আপনার ব্যালেন্সে অর্থ জমা করুন",
  total: "টোটাল",
  tournament: "টুর্নামেন্ট",
  tournamentCryptoReminderText: "To receive your winnings, do not forget to specify the Doge crypto wallet in your personal account ",
  tournamentDescription: "টুর্নামেন্টের বিবরণ",
  tournamentEnded: "টুর্নামেন্ট শেষ হয়েছে",
  tournamentGame: "গেমটি একটি টুর্নামেন্টে অংশ নেয়",
  tournamentGames: "টুর্নামেন্টের গেম",
  tournamentMounth: {
    "01": "জানুয়ারী",
    "02": "ফেব্রুয়ারি",
    "03": "মার্থা",
    "04": "এপ্রিল",
    "05": "মে",
    "06": "জুন",
    "07": "জুলাই",
    "08": "অগাস্টা",
    "09": "সেপ্টেম্বর",
    "10": "অক্টোবর",
    "11": "নভেম্বর",
    "12": "ডিসেম্বর"
  },
  tournaments: "টুর্নামেন্ট",
  transactionCopied: "আপনি লেনদেন আইডি কপি করেছেন",
  transactionSuccess: "লেনদেন সফলভাবে সম্পন্ন হয়েছে",
  transactionsIsNotExist: "আপনার এখনও কোনো লেনদেন হয়নি",
  transactionsNotFound: "নির্বাচিত ফিল্টারগুলির জন্য কোনও লেনদেন পাওয়া যায়নি৷ ফিল্টার প্যারামিটার বা {0} সম্পাদনা করার চেষ্টা করুন \n",
  transfer: "স্থানান্তর",
  transferAccount: "অ্যাকাউন্টে ট্রান্সফার করুন",
  transferAmount: "ট্রান্সফার করার জন্য অর্থের পরিমাণ লিখুন",
  transferAmount2: "ট্রান্সফার করার জন্য অর্থের পরিমাণ লিখুন",
  transferSuccessfully: "অর্থ ট্রান্সফার সফলভাবে সম্পন্ন হয়েছে",
  transferTheMoneyAndWait: "ক্যাশিয়ারকে অর্থ দিন এবং অর্থ জমা হওয়ার জন্য অপেক্ষা করুন",
  transitionDate: "লেনদেন তারিখ",
  transitionStatus: "লেনদেনের অবস্থা",
  transitionType: "লেনদেন প্রকার",
  turnOff: "বন্ধ করা",
  turnOn: "চালু করা",
  turnOnState: "অন",
  turnover: "টার্নওভার",
  twoFactorAuth: "টু-ফ্যাক্টর অথেন্টিকেশন",
  typeOfTransaction: "লেনদেন প্রকার",
  uncalculated: "অনিষ্পন্ন",
  underCoinBalanceClickGetButton: "কয়েন ব্যালেন্সের নিচে \"Get\"  বোতামে চাপুন। তারপর, বোতামটি ব্যবহার করে বা বারকোড স্ক্যান করে ঠিকানা কপি করুন",
  unexpectedErrorWriteToSupport: "একটি অপ্রত্যাশিত ত্রুটি ঘটেছে, কিন্তু আমরা শীঘ্রই এটি ঠিক করব।",
  unexpected_error_try_again: "অপ্রত্যাশিত ত্রুটি, আবার চেষ্টা করুন",
  unhandledErrorTryToRefreshPage: "অপ্রত্যাশিত ত্রুটি, অনুগ্রহ করে পেজটি রিলোড করুন",
  unselect: "নির্বাচন অপসারণ করুন",
  untilStartLeft: "শুরুর সময়",
  update: "রিফ্রেশ করুন",
  upload: "ডাউনলোড করুন",
  uzbek: "উজবেক",
  verification: "যাচাইকরণ",
  verificationDeclined: "আপনার যাচাইকরণ প্রত্যাখ্যান করা হয়েছে। অনুগ্রহ করে কাস্টোমার সাপোর্টের সাথে যোগাযোগ করুন",
  verificationDeclinedInfo: "ডকুমেন্ট যাচাই করা হয়নি অনুগ্রহ করে ডকুমেন্ট পুনরায় সংযুক্ত করুন বা কাস্টোমার সার্ভিসের সাথে যোগাযোগ করুন।",
  verificationInProgress: "আপনার যাচাইকরণ চলছে। অনুগ্রহ করে অপেক্ষা করুন",
  verificationsSMSDesc: "পেমেন্ট যাচাই করতে, নিবন্ধনের সময় আপনি যে ফোন নম্বর দিয়েছিলেন তা নিশ্চিত করুন",
  verifyYourAccount: "আপনার অ্যাকাউন্ট যাচাই করুন",
  virtuals: "ভার্চুয়াল",
  wager: "বাজি ধরা",
  wagerGame: {
    accessAfterRolePlay: "বোনাস বেট সম্পন্ন হওয়ার পরে গেমটি পাওয়া যাবে",
    gamesWagering: "যে গেমগুলোতে বাজি ধরা যায়",
    nowPlayed: "এখন বাজি ধরা হয়েছে",
    remainForPlay: "বাজি ধরার জন্য বাকি আছে"
  },
  wallet: "ওয়ালেট",
  walletCopied: "ওয়ালেট কপি করা হয়েছে",
  walletId: "ওয়ালেট ঠিকানা",
  walletNotLinked: "ওয়ালেট লিঙ্ক করা হয়নি",
  way: "উত্তোলন পদ্ধতি",
  ways: "উত্তোলন পদ্ধতিসমূহ",
  wbCashboxActiveText: "বোনাস অ্যাকাউন্টে জমা দেওয়ার জন্য 100% পেতে, আপনার অ্যাকাউন্টে {minSum} থেকে জমা করুন। বোনাস বাজি ধরার পর মূল অ্যাকাউন্ট পাওয়া যাবে।",
  wbCashboxNotActiveText: "বোনাস অ্যাকাউন্টে জমা দেওয়ার জন্য 100% পেতে, আপনার ব্যক্তিগত অ্যাকাউন্টে বোনাস সক্রিয় করুন।",
  wbWaitOnProfile: "আপনার অ্যাকাউন্টের \"বোনাস\" সেকশনে একটি ওয়েলকাম বোনাস আপনার জন্য অপেক্ষা করছে",
  welcomeBonus: "ওয়েলকাম বোনাস",
  welcomeBonusCasino: "স্বাগতম ক্যাসিনো বোনাস",
  welcomeBonusDescription: "Make a payment within an hour and get an increased bonus <span class='text-accent'>125%</span> for a deposit and up to 250 free spins!",
  welcomeBonusSport: "স্বাগতম স্পোর্টস বোনাস",
  welcomeBonusTitle: "+25% to Welcome bonus",
  win: "বিজয়",
  winnerPoints: "বিজয়:",
  winners: "জিতেছেন",
  withAnIncrease: "অডস বেশি হলে",
  withDrawOrdered: "প্রত্যাহার জারি করা হয়",
  withDrawOrderedDesc: "তার তহবিল শীঘ্রই আপনার নির্দিষ্ট অ্যাকাউন্টে জমা হবে।",
  withInstantCashback: "তাৎক্ষণিক ক্যাশব্যাকসহ",
  withdraw: "অর্থ উত্তোলন করা",
  withdraw2: "যেখানে উত্তোলন করবেন",
  withdrawBK: "বুকমেকারের কাছে উত্তোলন করুন",
  withdrawFunds: "অর্থ উত্তোলন করা",
  withdrawMethod: "উত্তোলন পদ্ধতি",
  withdrawMethods: "উত্তোলন পদ্ধতিসমূহ",
  withdrawNoun: "উত্তোলন করুন",
  withdrawPaymentInfo: "শুধুমাত্র আপনার লগইনের সাথে সংশ্লিষ্ট ভিসা/মাস্টারকার্ড-এ উত্তোলন সম্ভব। আপনাকে ভিসা/মাস্টারকার্ড দিয়ে আপনার লগইন জমা করতে হবে।",
  withdrawPerDayCountExceeded: "আপনি প্রতিদিন সর্বোচ্চ 1টি উত্তোলন করতে পারবেন",
  withdrawTelegramBot: "অর্থ উত্তোলন করতে, আপনাকে টেলিগ্রাম বট চালু করতে হবে এবং এতে লগইন করতে হবে",
  withdrawWithApprove: "তহবিল উত্তোলন এবং কোড নিশ্চিতকরণ",
  withdrawWithCode: "কনফার্মেশন কোড দিয়ে অর্থ উত্তোলন",
  withdrawal: "উত্তোলনের নিষেধাজ্ঞা",
  withdrawalCompletedSuccessfully: "উত্তোলনের অনুরোধ তৈরি হয়েছে",
  withdrawalOfFunds: "কনফার্মেশন কোড দিয়ে অর্থ উত্তোলন",
  work: "কারিগরি কাজ চলছে",
  writeToSupport: "সাপোর্টে যোগাযোগ করুন",
  yes: "হ্যাঁ",
  yesConfirm: "হ্যাঁ, আমি নিশ্চিত",
  yesOfCourseIWant: "হ্যাঁ, অবশ্যই আমি চাই",
  yesRefundWithdrawal: "হ্যাঁ, প্রত্যাহার বাতিল করুন",
  yesSure: "জি, আমি ডিপোজিট করেছি",
  you: "আপনি",
  youAreAuthorized: "আপনি লগইন করা অবস্থায় আছেন",
  youAreParticipateInTheTournament: "আপনি টুর্নামেন্টে অংশগ্রহণ করছেন!",
  youDontHaveTransactions: "আপনার এখনও কোনো লেনদেন হয়নি",
  youHaveNewMessage: "আপনার একটি নতুন ম্যাসেজ রয়েছে।",
  youHaveNotNewMessages: "আপনার কোনো নতুন ম্যাসেজ নেই",
  youHaveSmsVerification: "আপনি পেমেন্ট যাচাইকরণ সক্রিয় করেছেন, কোনো ট্রান্সফার করতে, SMS-এর মাধ্যমে যাচাইকরণের যান।",
  youTakePart: "আপনি অংশগ্রহণ করছেন",
  yourBalance: "আপনার ব্যালেন্স",
  yourCasinoBonus: "আপনার ক্যাসিনো বোনাস",
  yourCurrentEmail: "এখন আপনার ইমেইল",
  yourCurrentPhone: "এখন আপনার নম্বর",
  yourEmail: "আপনার ইমেইল",
  yourPersonalUniqueWalletIsDisplayedHere: "আপনার আগের নির্বাচিত কয়েনের জন্য একটি অনন্য ওয়ালেট এখানে প্রদর্শিত হবে। একটি বিশেষ বোতাম বা QR কোড ব্যবহার করে ওয়ালেট ঠিকানা কপি করা যাবে।"
} 
